(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["disc_finder_v2"] && !Shopify.designMode) return;
  try {
    
(() => {
const FALLBACK_RECOMMENDATIONS = {"distance_understable":[{"model":"Bolt","plastic":"Opto","handle":"opto-bolt","flight":[13,6,-2,3]},{"model":"Amber","plastic":"Opto","handle":"opto-amber","flight":[11,6,-3,2]}],"distance_neutral":[{"model":"Grace","plastic":"Royal Grand","handle":"grand-grace","flight":[11,6,-1,2]},{"model":"Flow","plastic":"Opto","handle":"opto-flow","flight":[11,6,-0.5,2]},{"model":"Ballista","plastic":"Opto","handle":"opto-ballista","flight":[14,5,-1,3]}],"distance_overstable":[{"model":"Rive","plastic":"Royal Grand","handle":"grand-rive","flight":[13,5,0,3.5]},{"model":"Ballista Pro","plastic":"Opto","handle":"opto-ballista-pro","flight":[14,4,0,3]},{"model":"Stiletto","plastic":"Opto","handle":"opto-stiletto-1","flight":[13,3,0.5,5]}],"fairway_understable":[{"model":"River","plastic":"Opto","handle":"opto-river-1","flight":[7,7,-1,1]},{"model":"Maul","plastic":"Opto","handle":"opto-maul","flight":[7,7,-2,1]},{"model":"Diamond","plastic":"Opto","handle":"opto-diamond","flight":[8,6,-3,1]},{"model":"Fury","plastic":"Opto","handle":"opto-fury","flight":[9,6,-2,2]}],"fairway_neutral":[{"model":"Explorer","plastic":"Opto","handle":"opto-explorer","flight":[7,5,0,2]},{"model":"Jade","plastic":"Opto","handle":"opto-jade","flight":[9,6,-2,1]},{"model":"Sapphire","plastic":"Opto","handle":"opto-sapphire-1","flight":[10,6,-2,1.5]}],"fairway_overstable":[{"model":"Pioneer","plastic":"Opto","handle":"opto-pioneer","flight":[9,3,0,4]},{"model":"Culverin","plastic":"Opto","handle":"opto-culverin-special-edition","flight":[9,5,-0.5,3]}],"midrange_understable":[{"model":"Fuse","plastic":"Opto","handle":"opto-fuse","flight":[5,6,-1,0]},{"model":"Pearl","plastic":"Opto","handle":"opto-pearl-3","flight":[4,6,-4,0]}],"midrange_neutral":[{"model":"Claymore","plastic":"Opto","handle":"opto-claymore","flight":[5,5,-1,1]},{"model":"Compass","plastic":"Opto","handle":"opto-compass","flight":[5,5,0,1]}],"midrange_overstable":[{"model":"Trust","plastic":"Royal Grand","handle":"grand-trust","flight":[5,5,0,2]},{"model":"Anchor","plastic":"Opto","handle":"opto-anchor","flight":[5,4,0,3]}],"putter_throwing_understable":[{"model":"Pure","plastic":"Opto","handle":"opto-pure","flight":[3,3,-1,1]}],"putter_throwing_neutral":[{"model":"Peak","plastic":"Royal Clear","handle":"clear-peak","flight":[3,3,0,1]},{"model":"Peak","plastic":"Royal Grand","handle":"grand-peak","flight":[3,3,0,1]}],"putter_throwing_overstable":[{"model":"Sinus","plastic":"Opto","handle":"opto-sinus","flight":[2,2,0,2]},{"model":"Savior","plastic":"Royal Clear","handle":"clear-savior","flight":[4,4,0,3]},{"model":"Savior","plastic":"Royal Grand","handle":"grand-savior","flight":[4,4,0,3]}],"putter_understable":[{"model":"Keystone","plastic":"Zero Medium","handle":"zero-medium-keystone","flight":[2,5,-1,1]},{"model":"Ruby","plastic":"Opto","handle":"opto-ruby","flight":[3,5,-3,1]}],"putter_neutral":[{"model":"Pure","plastic":"Zero Medium","handle":"zero-medium-pure","flight":[3,3,-1,1]},{"model":"Pure","plastic":"Opto","handle":"opto-pure","flight":[3,3,-1,1]}],"putter_overstable":[{"model":"Sinus","plastic":"Opto","handle":"opto-sinus","flight":[2,2,0,2]},{"model":"Caltrop","plastic":"Zero Medium","handle":"zero-medium-caltrop-special-edition","flight":[2,2,0,2]},{"model":"Savior","plastic":"Royal Sense","handle":"sense-savior","flight":[4,4,0,3]}],"easy_launch_easy":[{"model":"Grace","plastic":"Zero Gravity","handle":"zero-gravity-grace","typeKey":"distance","flight":[11,6,-1,2]},{"model":"Bolt","plastic":"Zero Gravity","handle":"zero-gravity-bolt","typeKey":"distance","flight":[13,6,-2,3]},{"model":"Diamond","plastic":"Zero Gravity","handle":"zero-gravity-diamond","typeKey":"fairway","flight":[8,6,-3,1]},{"model":"River","plastic":"Zero Gravity","handle":"zero-gravity-river","typeKey":"fairway","flight":[7,7,-1,1]},{"model":"Saint","plastic":"Zero Gravity","handle":"zero-gravity-saint","typeKey":"fairway","flight":[7,5,-1,2]},{"model":"Explorer","plastic":"Zero Gravity","handle":"zero-gravity-explorer","typeKey":"fairway","flight":[7,5,0,2]},{"model":"Fuse","plastic":"Zero Gravity","handle":"zero-gravity-fuse","typeKey":"midrange","flight":[5,6,-1,0]},{"model":"Pure","plastic":"Zero Gravity","handle":"zero-gravity-pure","typeKey":"putter","flight":[3,3,-1,1]}],"easy_launch_controlled":[{"model":"Amber","plastic":"Opto","handle":"opto-amber","typeKey":"distance","flight":[11,6,-3,2]},{"model":"Sapphire","plastic":"Opto","handle":"opto-sapphire-1","typeKey":"distance","flight":[10,6,-2,1.5]},{"model":"Jade","plastic":"Opto","handle":"opto-jade","typeKey":"fairway","flight":[9,6,-2,1]},{"model":"Diamond","plastic":"Opto","handle":"opto-diamond","typeKey":"fairway","flight":[8,6,-3,1]},{"model":"Explorer","plastic":"Zero Gravity","handle":"zero-gravity-explorer","typeKey":"fairway","flight":[7,5,0,2]},{"model":"Pearl","plastic":"Opto","handle":"opto-pearl-3","typeKey":"midrange","flight":[4,6,-4,0]},{"model":"Fuse","plastic":"Zero Gravity","handle":"zero-gravity-fuse","typeKey":"midrange","flight":[5,6,-1,0]},{"model":"Ruby","plastic":"Opto","handle":"opto-ruby","typeKey":"putter","flight":[3,5,-3,1]},{"model":"Pure","plastic":"Zero Gravity","handle":"zero-gravity-pure","typeKey":"putter","flight":[3,3,-1,1]}],"easy_launch_maximum":[{"model":"Amber","plastic":"Opto","handle":"opto-amber","typeKey":"distance","flight":[11,6,-3,2]},{"model":"Sapphire","plastic":"Opto","handle":"opto-sapphire-1","typeKey":"distance","flight":[10,6,-2,1.5]},{"model":"Grace","plastic":"Zero Gravity","handle":"zero-gravity-grace","typeKey":"distance","flight":[11,6,-1,2]},{"model":"Diamond","plastic":"Opto","handle":"opto-diamond","typeKey":"fairway","flight":[8,6,-3,1]},{"model":"Jade","plastic":"Opto","handle":"opto-jade","typeKey":"fairway","flight":[9,6,-2,1]},{"model":"River","plastic":"Zero Gravity","handle":"zero-gravity-river","typeKey":"fairway","flight":[7,7,-1,1]},{"model":"Pearl","plastic":"Opto","handle":"opto-pearl-3","typeKey":"midrange","flight":[4,6,-4,0]},{"model":"Fuse","plastic":"Zero Gravity","handle":"zero-gravity-fuse","typeKey":"midrange","flight":[5,6,-1,0]},{"model":"Ruby","plastic":"Opto","handle":"opto-ruby","typeKey":"putter","flight":[3,5,-3,1]}],"easy_launch_wind":[{"model":"Sapphire","plastic":"Opto","handle":"opto-sapphire-1","typeKey":"distance","flight":[10,6,-2,1.5]},{"model":"Amber","plastic":"Opto","handle":"opto-amber","typeKey":"distance","flight":[11,6,-3,2]},{"model":"Jade","plastic":"Opto","handle":"opto-jade","typeKey":"fairway","flight":[9,6,-2,1]},{"model":"Explorer","plastic":"Zero Gravity","handle":"zero-gravity-explorer","typeKey":"fairway","flight":[7,5,0,2]},{"model":"Pearl","plastic":"Opto","handle":"opto-pearl-3","typeKey":"midrange","flight":[4,6,-4,0]},{"model":"Fuse","plastic":"Zero Gravity","handle":"zero-gravity-fuse","typeKey":"midrange","flight":[5,6,-1,0]},{"model":"Ruby","plastic":"Opto","handle":"opto-ruby","typeKey":"putter","flight":[3,5,-3,1]},{"model":"Pure","plastic":"Opto","handle":"opto-pure","typeKey":"putter","flight":[3,3,-1,1]}]};

const compatibility = {
short: {
types: ['putter', 'midrange', 'fairway', 'catchplay'],
flights: {
putter: ['understable', 'straight'],
midrange: ['understable', 'straight'],
fairway: ['understable']
}
},
medium: {
types: ['putter', 'midrange', 'fairway', 'distance', 'catchplay'],
flights: {
putter: ['understable', 'straight', 'overstable'],
midrange: ['understable', 'straight', 'overstable'],
fairway: ['understable', 'straight', 'overstable'],
distance: ['understable', 'straight']
}
},
long: {
types: ['putter', 'midrange', 'fairway', 'distance', 'catchplay'],
flights: {
putter: ['understable', 'straight', 'overstable'],
midrange: ['understable', 'straight', 'overstable'],
fairway: ['understable', 'straight', 'overstable'],
distance: ['understable', 'straight', 'overstable']
}
}
};

const parseJson = (element, fallback) => {
if (!element) return fallback;
try {
return JSON.parse(element.textContent || '');
} catch (error) {
return fallback;
}
};

const normalizeText = (value) => String(value || '').trim().toLowerCase();

const normalizeImageUrl = (value) => {
if (!value) return '';
if (typeof value === 'string') return value;
return value.src || value.url || '';
};

const initFinder = (root) => {
if (!root || root.dataset.discFinderV2Ready === 'true') return;

const form = root.querySelector('[data-disc-finder-form]');
const distance = root.querySelector('[data-disc-distance]');
const type = root.querySelector('[data-disc-type]');
const goal = root.querySelector('[data-disc-goal]');
const use = root.querySelector('[data-disc-use]');
const profile = root.querySelector('[data-disc-profile]');
const rim = root.querySelector('[data-disc-rim]');
const flight = root.querySelector('[data-disc-flight]');
const goalField = root.querySelector('[data-disc-goal-field]');
const useField = root.querySelector('[data-disc-use-field]');
const profileField = root.querySelector('[data-disc-profile-field]');
const rimField = root.querySelector('[data-disc-rim-field]');
const flightField = root.querySelector('[data-disc-flight-field]');
const flightStep = root.querySelector('[data-flight-step]');
const useStep = root.querySelector('[data-use-step]');
const profileStep = root.querySelector('[data-profile-step]');
const rimStep = root.querySelector('[data-rim-step]');
const distanceField = root.querySelector('[data-disc-field="distance"]');
const typeField = root.querySelector('[data-disc-field="type"]');
const submit = root.querySelector('[data-disc-submit]');
const results = root.querySelector('[data-results]');
const loading = root.querySelector('[data-loading]');
const primaryCard = root.querySelector('[data-primary-card]');
const alternativesWrap = root.querySelector('[data-alternatives-wrap]');
const alternatives = root.querySelector('[data-alternatives]');
const bundleRecommendation = root.querySelector('[data-bundle-recommendation]');
const viewAll = root.querySelector('[data-view-all]');
const resultContext = root.querySelector('[data-result-context]');
const live = root.querySelector('[data-status-live]');
const config = parseJson(root.querySelector('[data-disc-finder-config]'), { strings: {} });
const curated = parseJson(root.querySelector('[data-disc-finder-curated]'), {});
const bundleData = parseJson(root.querySelector('[data-disc-finder-bundles]'), { enabled: false, products: {} });
const decodeText = (value) => {
const textarea = document.createElement('textarea');
textarea.innerHTML = String(value || '');
return textarea.value;
};
const t = Object.fromEntries(
Object.entries(config.strings || {}).map(([key, value]) => [key, decodeText(value)])
);

if (!form || !distance || !type || !goal || !use || !profile || !rim || !flight || !goalField || !useField || !profileField || !rimField || !flightField || !distanceField || !typeField || !submit || !results || !primaryCard || !alternatives || !viewAll) return;

root.dataset.discFinderV2Ready = 'true';

const maxResults = Math.max(2, Math.min(5, Number(root.dataset.maxResults || 4)));
const personalizeByDistance = root.dataset.personalizeDistance === 'true';
const enableAnalytics = root.dataset.enableAnalytics === 'true';
const currency = root.dataset.currency || 'USD';
const storefrontLocale = root.dataset.locale || document.documentElement.lang || 'en';
const bundleSaveUrl = root.dataset.bundleSaveUrl || '';
const zeroGravityUrl = root.dataset.zeroGravityUrl || '';
const easyToUseUrl = root.dataset.easyToUseUrl || '';
const finderMode = root.dataset.finderMode || 'general';
const focusedTypeMap = {
distance_driver: 'distance',
fairway_driver: 'fairway',
midrange: 'midrange',
putt_approach: 'putter'
};
const focusedTypeKey = focusedTypeMap[finderMode] || '';
const isGoalFocused = ['distance', 'fairway', 'midrange'].includes(focusedTypeKey);
const isPuttFocused = focusedTypeKey === 'putter';
const isEasyLaunchFocused = finderMode === 'easy_launch';
const isBeginnerFocused = finderMode === 'beginner';
let currentChoices = [];
let currentChoiceIndex = 0;
let currentZone = '';
let currentFlightKey = '';
let viewed = false;

const shopRoot = () => window.Shopify && window.Shopify.routes && window.Shopify.routes.root
? window.Shopify.routes.root
: (root.dataset.rootUrl || '/');

const announce = (message) => {
if (!live) return;
live.textContent = '';
window.requestAnimationFrame(() => { live.textContent = message || ''; });
};

const track = (eventName, payload = {}, klaviyoName = '') => {
if (!enableAnalytics) return;
const data = { ...payload, section_id: root.id };
try {
if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
Promise.resolve(window.Shopify.analytics.publish(`latitude64:disc_finder_${eventName}`, data)).catch(() => {});
}
} catch (error) {
}
if (klaviyoName && window.klaviyo && typeof window.klaviyo.push === 'function') {
try { window.klaviyo.push(['track', klaviyoName, data]); } catch (error) {}
}
};

if ('IntersectionObserver' in window) {
const observer = new IntersectionObserver((entries) => {
if (viewed || !entries.some((entry) => entry.isIntersecting)) return;
viewed = true;
track('viewed', {}, 'Disc Finder - Viewed');
observer.disconnect();
}, { threshold: 0.25 });
observer.observe(root);
}

const formatMoney = (cents) => {
const amount = Number(cents);
if (!Number.isFinite(amount)) return '';

const nordicMoneyLocale = {
SEK: 'sv-SE',
NOK: 'nb-NO',
DKK: 'da-DK'
};
const moneyLocale = nordicMoneyLocale[currency] || storefrontLocale;
const currencyDisplay = nordicMoneyLocale[currency] ? 'narrowSymbol' : 'symbol';

try {
return new Intl.NumberFormat(moneyLocale, {
style: 'currency',
currency,
currencyDisplay,
minimumFractionDigits: 2,
maximumFractionDigits: 2
}).format(amount / 100);
} catch (error) {
if (nordicMoneyLocale[currency]) return `${(amount / 100).toFixed(2)} kr`;
return `${(amount / 100).toFixed(2)} ${currency}`;
}
};

const selectedOption = (select) => select.options[select.selectedIndex] || null;
const selectedKey = (select, attribute) => {
const option = selectedOption(select);
return option ? option.dataset[attribute] || '' : '';
};

const typePlaceholder = type.options[0].cloneNode(true);
const goalPlaceholder = goal.options[0].cloneNode(true);
const flightPlaceholder = flight.options[0].cloneNode(true);
const typeOptionBank = Array.from(type.options).slice(1).map((option) => option.cloneNode(true));
const goalOptionBank = Array.from(goal.options).slice(1).map((option) => option.cloneNode(true));
const flightOptionBank = Array.from(flight.options).slice(1).map((option) => option.cloneNode(true));

const rebuildOptions = (select, placeholder, optionBank, allowedKeys, attribute) => {
const options = [placeholder.cloneNode(true)];
optionBank.forEach((option) => {
const key = option.dataset[attribute] || '';
if (allowedKeys.includes(key)) options.push(option.cloneNode(true));
});
select.replaceChildren(...options);
select.value = '';
};

const currentDistanceKey = () => selectedKey(distance, 'distanceKey');
const currentTypeValue = () => type.value;
const currentGoalKey = () => selectedKey(goal, 'goalKey');
const currentTypeKey = () => selectedKey(type, 'typeKey');
const currentUseKey = () => selectedKey(use, 'useKey');
const currentProfileValue = () => selectedOption(profile)?.dataset.profileValue || '';
const currentRimValue = () => selectedOption(rim)?.dataset.rimValue || '';
const currentFlightKeyValue = () => selectedKey(flight, 'flightKey');

const setFocusedType = () => {
const focusedOption = typeOptionBank.find((option) => (option.dataset.typeKey || '') === focusedTypeKey);
const options = [typePlaceholder.cloneNode(true)];
if (focusedOption) options.push(focusedOption.cloneNode(true));
type.replaceChildren(...options);
type.value = focusedOption ? focusedOption.value : '';
type.disabled = true;
typeField.hidden = true;
};

const focusedGoalKeys = (distanceKey) => {
if (!distanceKey || !isGoalFocused) return [];
if (distanceKey === 'short') {
if (focusedTypeKey === 'distance') return ['easy', 'controlled'];
return ['easy', 'maximum', 'controlled'];
}
return ['easy', 'maximum', 'controlled', 'wind'];
};

const focusedFlightKeys = (distanceKey) => {
if (!distanceKey || !isGoalFocused) return [];
if (distanceKey === 'short') return ['understable', 'straight'];
return ['understable', 'straight', 'overstable'];
};

const resetFocusedGoalFields = () => {
setAdvancedHidden();
setFocusedType();
rebuildOptions(goal, goalPlaceholder, goalOptionBank, focusedGoalKeys(currentDistanceKey()), 'goalKey');
goal.disabled = !distance.value;
goalField.hidden = false;
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = false;
if (flightStep) flightStep.textContent = '3';
form.classList.remove('is-putter', 'is-catch-play');
form.classList.add('is-distance-focused');
};

const resetFocusedPutterFields = () => {
setFocusedType();
goal.value = '';
goal.disabled = true;
goalField.hidden = true;
use.value = '';
use.disabled = !distance.value;
useField.hidden = false;
profile.value = 'any';
profile.disabled = true;
profileField.hidden = true;
rim.value = 'any';
rim.disabled = true;
rimField.hidden = true;
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = true;
if (useStep) useStep.textContent = '2';
if (profileStep) profileStep.textContent = '3';
if (rimStep) rimStep.textContent = '4';
if (flightStep) flightStep.textContent = '4';
form.classList.remove('is-catch-play', 'is-distance-focused');
form.classList.add('is-putter');
};

const resetEasyLaunchFields = () => {
distance.value = '';
distance.disabled = true;
distanceField.hidden = true;
rebuildOptions(goal, goalPlaceholder, goalOptionBank, ['easy', 'maximum', 'controlled', 'wind'], 'goalKey');
goal.disabled = false;
goalField.hidden = false;
rebuildOptions(type, typePlaceholder, typeOptionBank, [], 'typeKey');
type.disabled = true;
typeField.hidden = false;
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = true;
setAdvancedHidden();
form.classList.remove('is-catch-play', 'is-putter', 'is-distance-focused');
form.classList.add('is-easy-launch');
};

const updateEasyLaunchGoal = () => {
const allowedTypes = goal.value ? ['putter', 'midrange', 'fairway', 'distance'] : [];
rebuildOptions(type, typePlaceholder, typeOptionBank, allowedTypes, 'typeKey');
type.disabled = allowedTypes.length === 0;
typeField.hidden = false;
updateSubmit();
};

const setAdvancedHidden = () => {
use.value = '';
profile.value = 'any';
rim.value = 'any';
use.disabled = true;
profile.disabled = true;
rim.disabled = true;
useField.hidden = true;
profileField.hidden = true;
rimField.hidden = true;
};

const syncFieldStates = () => {
const typeKey = currentTypeKey();
if (isEasyLaunchFocused) {
const goalComplete = Boolean(goal.value);
const typeComplete = Boolean(type.value);
goalField.classList.toggle('is-complete', goalComplete);
goalField.classList.toggle('is-active', !goalComplete);
typeField.classList.toggle('is-complete', typeComplete);
typeField.classList.toggle('is-active', goalComplete && !typeComplete);
return;
}
if (isGoalFocused) {
const distanceComplete = Boolean(distance.value);
const goalComplete = Boolean(goal.value);
const flightComplete = Boolean(flight.value);
distanceField.classList.toggle('is-complete', distanceComplete);
distanceField.classList.toggle('is-active', !distanceComplete);
goalField.classList.toggle('is-complete', goalComplete);
goalField.classList.toggle('is-active', distanceComplete && !goalComplete);
flightField.classList.toggle('is-complete', flightComplete);
flightField.classList.toggle('is-active', goalComplete && !flightComplete);
return;
}
if (isBeginnerFocused) {
const distanceComplete = Boolean(distance.value);
const typeComplete = Boolean(type.value);
const flightComplete = Boolean(flight.value);
distanceField.classList.toggle('is-complete', distanceComplete);
distanceField.classList.toggle('is-active', !distanceComplete);
typeField.classList.toggle('is-complete', typeComplete);
typeField.classList.toggle('is-active', distanceComplete && !typeComplete);
flightField.classList.toggle('is-complete', flightComplete);
flightField.classList.toggle('is-active', typeComplete && !flightComplete);
return;
}
if (isPuttFocused) {
const distanceComplete = Boolean(distance.value);
const useKey = currentUseKey();
const useComplete = Boolean(use.value);
const flightRequired = useKey === 'throwing' || useKey === 'approach' || useKey === 'both';
const flightComplete = !flightRequired || Boolean(flight.value);
distanceField.classList.toggle('is-complete', distanceComplete);
distanceField.classList.toggle('is-active', !distanceComplete);
useField.classList.toggle('is-complete', useComplete);
useField.classList.toggle('is-active', distanceComplete && !useComplete);
profileField.classList.toggle('is-complete', useComplete);
profileField.classList.toggle('is-active', useComplete);
rimField.classList.toggle('is-complete', useKey === 'putting');
rimField.classList.toggle('is-active', useKey === 'putting');
flightField.classList.toggle('is-complete', flightRequired && flightComplete);
flightField.classList.toggle('is-active', flightRequired && !flightComplete);
return;
}
const useKey = currentUseKey();
const distanceComplete = Boolean(distance.value);
const typeComplete = Boolean(type.value);
const useComplete = typeKey !== 'putter' || Boolean(use.value);
const flightRequired = typeKey !== 'putter' || useKey === 'throwing' || useKey === 'approach' || useKey === 'both';
const flightComplete = typeKey === 'catchplay' || !flightRequired || Boolean(flight.value);

distanceField.classList.toggle('is-complete', distanceComplete);
distanceField.classList.toggle('is-active', !distanceComplete);
typeField.classList.toggle('is-complete', typeComplete);
typeField.classList.toggle('is-active', distanceComplete && !typeComplete);
useField.classList.toggle('is-complete', typeKey === 'putter' && Boolean(use.value));
useField.classList.toggle('is-active', typeKey === 'putter' && typeComplete && !use.value);
profileField.classList.toggle('is-complete', typeKey === 'putter' && Boolean(use.value));
profileField.classList.toggle('is-active', typeKey === 'putter' && Boolean(use.value));
rimField.classList.toggle('is-complete', typeKey === 'putter' && useKey === 'putting');
rimField.classList.toggle('is-active', typeKey === 'putter' && useKey === 'putting');
flightField.classList.toggle('is-complete', typeComplete && flightComplete);
flightField.classList.toggle('is-active', typeComplete && flightRequired && !flight.value);
};

const updateSubmit = () => {
const typeKey = currentTypeKey();
if (isEasyLaunchFocused) {
submit.disabled = !(goal.value && type.value);
syncFieldStates();
return;
}
if (isGoalFocused) {
submit.disabled = !(distance.value && goal.value && flight.value);
syncFieldStates();
return;
}
const useKey = currentUseKey();
if (isBeginnerFocused) {
submit.disabled = !(distance.value && type.value && flight.value);
syncFieldStates();
return;
}
if (typeKey === 'catchplay') {
submit.disabled = !(distance.value && type.value);
} else if (typeKey === 'putter') {
const needsFlight = useKey === 'throwing' || useKey === 'approach' || useKey === 'both';
submit.disabled = !(distance.value && type.value && use.value && (!needsFlight || flight.value));
} else {
submit.disabled = !(distance.value && type.value && flight.value);
}
syncFieldStates();
};

const updateFocusedDistance = () => {
setFocusedType();
rebuildOptions(goal, goalPlaceholder, goalOptionBank, focusedGoalKeys(currentDistanceKey()), 'goalKey');
goal.disabled = !distance.value;
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = false;
if (flightStep) flightStep.textContent = '3';
updateSubmit();
};

const updateFocusedPutterDistance = () => {
resetFocusedPutterFields();
updateSubmit();
};

const updateFocusedGoal = () => {
const allowed = goal.value ? focusedFlightKeys(currentDistanceKey()) : [];
rebuildOptions(flight, flightPlaceholder, flightOptionBank, allowed, 'flightKey');
flight.disabled = allowed.length === 0;
flightField.hidden = false;
if (flightStep) flightStep.textContent = '3';
updateSubmit();
};

const updatePutterUse = () => {
const useKey = currentUseKey();
profileField.hidden = !useKey;
profile.disabled = !useKey;
rim.value = 'any';
rimField.hidden = useKey !== 'putting';
rim.disabled = useKey !== 'putting';

if (useKey === 'throwing' || useKey === 'approach' || useKey === 'both') {
flightField.hidden = false;
if (flightStep) flightStep.textContent = isPuttFocused ? '4' : '5';
rebuildOptions(flight, flightPlaceholder, flightOptionBank, ['understable', 'straight', 'overstable'], 'flightKey');
flight.disabled = false;
} else {
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = true;
}
updateSubmit();
};

const updateFlightOptions = () => {
const distanceKey = currentDistanceKey();
const typeValue = currentTypeValue();
const typeKey = currentTypeKey();

setAdvancedHidden();
form.classList.remove('is-putter', 'is-catch-play');

if (typeKey === 'catchplay') {
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = true;
form.classList.add('is-catch-play');
updateSubmit();
return;
}

if (typeKey === 'putter') {
if (isBeginnerFocused) {
setAdvancedHidden();
flightField.hidden = false;
if (flightStep) flightStep.textContent = '3';
const beginnerPutterFlights = distanceKey === 'short'
? ['understable', 'straight', 'not_sure']
: ['understable', 'straight', 'overstable', 'not_sure'];
rebuildOptions(flight, flightPlaceholder, flightOptionBank, beginnerPutterFlights, 'flightKey');
flight.disabled = false;
updateSubmit();
return;
}
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
flight.disabled = true;
flightField.hidden = true;
useField.hidden = false;
use.disabled = false;
if (flightStep) flightStep.textContent = '5';
form.classList.add('is-putter');
updateSubmit();
return;
}

flightField.hidden = false;
if (flightStep) flightStep.textContent = '3';
let allowed = compatibility[distanceKey]?.flights?.[typeValue] || [];
if (isBeginnerFocused && typeKey === 'beginner_mix') {
allowed = distanceKey === 'short'
? ['understable', 'straight', 'not_sure']
: ['understable', 'straight', 'overstable', 'not_sure'];
} else if (isBeginnerFocused) {
allowed = allowed.concat('not_sure');
}
rebuildOptions(flight, flightPlaceholder, flightOptionBank, allowed, 'flightKey');
flight.disabled = allowed.length === 0;
updateSubmit();
};

const updateTypeOptions = () => {
const distanceKey = currentDistanceKey();
const allowed = isBeginnerFocused
? (distanceKey === 'short'
? ['putter', 'midrange', 'fairway', 'beginner_mix']
: ['putter', 'midrange', 'fairway', 'distance', 'beginner_mix'])
: (compatibility[distanceKey]?.types || []);
rebuildOptions(type, typePlaceholder, typeOptionBank, allowed, 'typeKey');
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
setAdvancedHidden();
type.disabled = allowed.length === 0;
flight.disabled = true;
flightField.hidden = false;
if (flightStep) flightStep.textContent = '3';
form.classList.remove('is-catch-play', 'is-putter');
updateSubmit();
};

const targetSpeed = (distanceKey, typeKey) => {
const targets = {
short: { putter: 2.5, midrange: 5, fairway: 7 },
medium: { putter: 2.5, midrange: 5, fairway: 8, distance: 11 },
long: { putter: 3, midrange: 5.5, fairway: 9, distance: 13 }
};
return targets[distanceKey]?.[typeKey] || null;
};

const recommendationSpeed = (recommendation) => {
const speed = Number(recommendation && recommendation.flight && recommendation.flight.speed);
return Number.isFinite(speed) ? speed : null;
};

const sortByDistance = (items, distanceKey, typeKey) => {
if (!personalizeByDistance || items.length < 2) return items.slice();
const target = targetSpeed(distanceKey, typeKey);
if (!Number.isFinite(target)) return items.slice();
return items
.map((item, index) => ({ item, index, speed: recommendationSpeed(item) }))
.sort((a, b) => {
const aDelta = Number.isFinite(a.speed) ? Math.abs(a.speed - target) : 99;
const bDelta = Number.isFinite(b.speed) ? Math.abs(b.speed - target) : 99;
return aDelta - bDelta || a.index - b.index;
})
.map((entry) => entry.item);
};

const flightNumber = (recommendation, key) => {
const value = Number(recommendation?.flight?.[key]);
return Number.isFinite(value) ? value : null;
};

const distanceDriverGoalScore = (recommendation, distanceKey, goalKey) => {
const speed = flightNumber(recommendation, 'speed');
const glide = flightNumber(recommendation, 'glide');
const turn = flightNumber(recommendation, 'turn');
const fade = flightNumber(recommendation, 'fade');
const baseSpeed = { short: 10, medium: 11.5, long: 13 }[distanceKey] || 11.5;
const missingPenalty = (value) => Number.isFinite(value) ? 0 : 12;
let score = missingPenalty(speed) + missingPenalty(glide) + missingPenalty(turn) + missingPenalty(fade);

if (goalKey === 'easy') {
const targetSpeed = baseSpeed - 1.5;
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - targetSpeed) * 4;
if (Number.isFinite(glide)) score += (7 - glide) * 1.4;
if (Number.isFinite(turn)) score += Math.abs(turn - (distanceKey === 'long' ? -1.5 : -2.5)) * 1.8;
if (Number.isFinite(fade)) score += Math.abs(fade - 1.5) * .8;
} else if (goalKey === 'maximum') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 3.6;
if (Number.isFinite(glide)) score += (7 - glide) * 1.5;
if (Number.isFinite(turn)) score += Math.abs(turn + 1.5) * 1.2;
if (Number.isFinite(fade)) score += Math.abs(fade - 2) * .6;
} else if (goalKey === 'controlled') {
const targetSpeed = baseSpeed - .75;
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - targetSpeed) * 4;
if (Number.isFinite(glide)) score += Math.abs(glide - 5.5) * .6;
if (Number.isFinite(turn)) score += Math.abs(turn + 1) * 1.7;
if (Number.isFinite(fade)) score += Math.abs(fade - 2.25) * 1.1;
} else if (goalKey === 'wind') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 2.4;
if (Number.isFinite(turn)) score += Math.abs(turn - 0) * 2.8;
if (Number.isFinite(fade)) score += Math.abs(fade - 3.5) * 2.2;
if (Number.isFinite(glide)) score += Math.max(0, glide - 5) * .4;
} else if (personalizeByDistance && Number.isFinite(speed)) {
score += Math.abs(speed - baseSpeed) * 3;
}
return score;
};

const fairwayGoalScore = (recommendation, distanceKey, goalKey) => {
const speed = flightNumber(recommendation, 'speed');
const glide = flightNumber(recommendation, 'glide');
const turn = flightNumber(recommendation, 'turn');
const fade = flightNumber(recommendation, 'fade');
const baseSpeed = { short: 7, medium: 8, long: 9 }[distanceKey] || 8;
const missingPenalty = (value) => Number.isFinite(value) ? 0 : 12;
let score = missingPenalty(speed) + missingPenalty(glide) + missingPenalty(turn) + missingPenalty(fade);

if (goalKey === 'easy') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - (baseSpeed - .5)) * 4;
if (Number.isFinite(glide)) score += (7 - glide) * 1.4;
if (Number.isFinite(turn)) score += Math.abs(turn - (distanceKey === 'long' ? -1 : -2)) * 1.7;
if (Number.isFinite(fade)) score += Math.abs(fade - 1.25) * .8;
} else if (goalKey === 'maximum') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 3;
if (Number.isFinite(glide)) score += (7 - glide) * 1.1;
if (Number.isFinite(turn)) score += Math.abs(turn + 2) * 2;
if (Number.isFinite(fade)) score += Math.abs(fade - 1.25) * .8;
} else if (goalKey === 'controlled') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 3.6;
if (Number.isFinite(glide)) score += Math.abs(glide - 5.5) * .6;
if (Number.isFinite(turn)) score += Math.abs(turn + .5) * 1.8;
if (Number.isFinite(fade)) score += Math.abs(fade - 2) * 1.2;
} else if (goalKey === 'wind') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 2.2;
if (Number.isFinite(turn)) score += Math.abs(turn) * 2.8;
if (Number.isFinite(fade)) score += Math.abs(fade - 3.25) * 2.1;
if (Number.isFinite(glide)) score += Math.max(0, glide - 5) * .5;
}
return score;
};

const midrangeGoalScore = (recommendation, distanceKey, goalKey) => {
const speed = flightNumber(recommendation, 'speed');
const glide = flightNumber(recommendation, 'glide');
const turn = flightNumber(recommendation, 'turn');
const fade = flightNumber(recommendation, 'fade');
const baseSpeed = { short: 4.5, medium: 5, long: 5.5 }[distanceKey] || 5;
const missingPenalty = (value) => Number.isFinite(value) ? 0 : 12;
let score = missingPenalty(speed) + missingPenalty(glide) + missingPenalty(turn) + missingPenalty(fade);

if (goalKey === 'easy') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 4;
if (Number.isFinite(glide)) score += (6.5 - glide) * 1.3;
if (Number.isFinite(turn)) score += Math.abs(turn + 1.5) * 1.5;
if (Number.isFinite(fade)) score += Math.abs(fade - 1) * .8;
} else if (goalKey === 'maximum') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 2.6;
if (Number.isFinite(glide)) score += (6.5 - glide) * .8;
if (Number.isFinite(turn) && Number.isFinite(fade)) score -= Math.min(3, Math.abs(turn) + fade) * .35;
} else if (goalKey === 'controlled') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 3.5;
if (Number.isFinite(glide)) score += Math.abs(glide - 5) * .7;
if (Number.isFinite(turn)) score += Math.abs(turn + .25) * 1.8;
if (Number.isFinite(fade)) score += Math.abs(fade - 1.5) * 1.1;
} else if (goalKey === 'wind') {
if (personalizeByDistance && Number.isFinite(speed)) score += Math.abs(speed - baseSpeed) * 2.3;
if (Number.isFinite(turn)) score += Math.abs(turn) * 2.8;
if (Number.isFinite(fade)) score += Math.abs(fade - 2.75) * 2;
if (Number.isFinite(glide)) score += Math.max(0, glide - 5) * .5;
}
return score;
};

const focusedGoalScore = (recommendation, distanceKey, typeKey, goalKey) => {
if (typeKey === 'distance') return distanceDriverGoalScore(recommendation, distanceKey, goalKey);
if (typeKey === 'fairway') return fairwayGoalScore(recommendation, distanceKey, goalKey);
if (typeKey === 'midrange') return midrangeGoalScore(recommendation, distanceKey, goalKey);
return 0;
};

const prioritizeFocusedCandidates = (items, distanceKey, typeKey, goalKey) => items
.map((item, index) => ({ item, index, score: focusedGoalScore(item, distanceKey, typeKey, goalKey) }))
.sort((a, b) => a.score - b.score || a.index - b.index)
.map((entry) => entry.item);

const normalizeList = (value) => {
if (Array.isArray(value)) return value.map(normalizeText).filter(Boolean);
if (typeof value !== 'string') return [];
const trimmed = value.trim();
if (!trimmed) return [];
if (trimmed.startsWith('[')) {
try {
const parsed = JSON.parse(trimmed);
if (Array.isArray(parsed)) return parsed.map(normalizeText).filter(Boolean);
} catch (error) {
}
}
return trimmed.split(',').map(normalizeText).filter(Boolean);
};

const putterUseRank = (recommendation, useKey) => {
const uses = normalizeList(recommendation?.discFinderUse);
if (!useKey) return 0;

if (useKey === 'putting' || useKey === 'approach') {
if (uses.includes(useKey)) return 0;
if (!uses.length) return 1;
return 2;
}

if (useKey === 'both') {
const hasPutting = uses.includes('putting');
const hasApproach = uses.includes('approach');
if (hasPutting && hasApproach) return 0;
if (hasPutting || hasApproach) return 1;
if (!uses.length) return 2;
return 3;
}

return 0;
};

const putterProfileRank = (recommendation, requestedProfile) => {
if (!requestedProfile) return 0;
const actualProfile = normalizeText(recommendation?.discHeight);
if (actualProfile === requestedProfile) return 0;
if (!actualProfile) return 1;
return 2;
};

const putterRimRank = (recommendation, requestedRim) => {
if (!requestedRim) return 0;
const actualRim = normalizeText(recommendation?.rimType);
if (actualRim === requestedRim) return 0;
if (!actualRim) return 1;
return 2;
};

const puttingStabilityRank = (recommendation, useKey) => {
if (useKey !== 'putting') return 0;
const zone = normalizeText(recommendation?.finderZone);
if (zone === 'putter_neutral') return 0;
if (zone === 'putter_understable') return 1;
if (zone === 'putter_overstable') return 2;
return 1;
};

const sourceRank = (recommendation) => recommendation?.source === 'curated' ? 0 : 1;

const sortPutterCandidates = (items, preferences) => {
const useKey = preferences.useKey || '';
const requestedProfile = normalizeText(preferences.profileValue);
const requestedRim = normalizeText(preferences.rimValue);

return items
.map((item, index) => ({
item,
index,
useRank: preferences.curatedRole ? 0 : putterUseRank(item, useKey),
profileRank: putterProfileRank(item, requestedProfile),
rimRank: putterRimRank(item, requestedRim),
stabilityRank: puttingStabilityRank(item, useKey),
sourceRank: sourceRank(item)
}))
.sort((a, b) => (
a.useRank - b.useRank
|| a.profileRank - b.profileRank
|| a.rimRank - b.rimRank
|| a.stabilityRank - b.stabilityRank
|| a.sourceRank - b.sourceRank
|| a.index - b.index
))
.map((entry) => entry.item);
};

const prioritizePutterCandidates = (items, preferences) => {
if (!items.length) return [];

const useKey = preferences.useKey || '';
const requestedProfile = normalizeText(preferences.profileValue);
const requestedRim = normalizeText(preferences.rimValue);
let usePool = items.slice();

if (!preferences.curatedRole && (useKey === 'putting' || useKey === 'approach')) {
const exactUse = items.filter((item) => putterUseRank(item, useKey) === 0);
const unspecifiedUse = items.filter((item) => putterUseRank(item, useKey) === 1);
if (exactUse.length) usePool = exactUse;
else if (unspecifiedUse.length) usePool = unspecifiedUse;
} else if (!preferences.curatedRole && useKey === 'both') {
const exactBoth = items.filter((item) => putterUseRank(item, useKey) === 0);
const partialBoth = items.filter((item) => putterUseRank(item, useKey) === 1);
const unspecifiedUse = items.filter((item) => putterUseRank(item, useKey) === 2);
if (exactBoth.length) usePool = exactBoth;
else if (partialBoth.length) usePool = partialBoth;
else if (unspecifiedUse.length) usePool = unspecifiedUse;
}

let profilePool = usePool;
if (requestedProfile) {
const exactProfile = usePool.filter((item) => normalizeText(item?.discHeight) === requestedProfile);
if (exactProfile.length) profilePool = exactProfile;
}

let strictPool = profilePool;
if (requestedRim) {
const exactRim = profilePool.filter((item) => normalizeText(item?.rimType) === requestedRim);
if (exactRim.length) strictPool = exactRim;
}

const ordered = [];
const seen = new Set();
const appendPool = (pool) => {
sortPutterCandidates(pool, preferences).forEach((item) => {
const key = `${normalizeText(item?.handle)}|${normalizeText(item?.model)}|${normalizeText(item?.plastic)}`;
if (!item || !item.handle || seen.has(key)) return;
seen.add(key);
ordered.push(item);
});
};

appendPool(strictPool);
if (strictPool !== profilePool) appendPool(profilePool);
if (profilePool !== usePool) appendPool(usePool);

return ordered;
};

const easyLaunchRecommendationChoices = (goalKey, typeKey) => {
const zone = `easy_launch_${goalKey}`;
const curatedPool = Array.isArray(curated[zone])
? curated[zone].filter((item) => normalizeText(item?.typeKey) === normalizeText(typeKey))
: [];
const fallbackPool = Array.isArray(FALLBACK_RECOMMENDATIONS[zone])
? FALLBACK_RECOMMENDATIONS[zone].filter((item) => normalizeText(item?.typeKey) === normalizeText(typeKey))
: [];
const source = curatedPool.length ? curatedPool : fallbackPool.map((item) => ({
...item,
flight: { speed: item.flight[0], glide: item.flight[1], turn: item.flight[2], fade: item.flight[3] },
variants: [],
loaded: false,
available: true,
bundleSave: false,
customReason: '',
discFinderUse: [],
rimType: '',
discHeight: '',
stability: '',
priceDisplay: '',
image: '',
productTitle: item.model,
source: 'fallback'
}));
const seen = new Set();
return source.filter((item) => {
if (!item || !item.handle || seen.has(item.handle)) return false;
seen.add(item.handle);
return true;
}).slice(0, Math.min(3, maxResults));
};

const beginnerRecommendationChoices = (distanceKey, typeKey, flightKey) => {
const effectiveDistance = distanceKey || 'short';
const defaultFlight = effectiveDistance === 'short' ? 'understable' : 'straight';
const effectiveFlight = flightKey === 'not_sure' ? defaultFlight : (flightKey || defaultFlight);
const stabilityKey = effectiveFlight === 'straight' ? 'neutral' : effectiveFlight;

/* If the beginner selects "I'm not sure" for all three questions,
   favor the most universally useful beginner-friendly midranges first.
   Keep Zero Medium Keystone out of this fallback mix. */
if (effectiveDistance === 'short' && typeKey === 'beginner_mix' && flightKey === 'not_sure') {
const preferredHandles = ['opto-fuse', 'opto-pearl-3'];
const candidatePools = [
recommendationChoices('midrange_understable', effectiveDistance, 'midrange', { stabilityKey: 'understable' }),
recommendationChoices('fairway_understable', effectiveDistance, 'fairway', { stabilityKey: 'understable' }),
recommendationChoices('putter_understable', effectiveDistance, 'putter', { useKey: 'approach', stabilityKey: 'understable' })
];

const flat = candidatePools.flat().filter((item) => normalizeText(item?.handle) !== 'zero-medium-keystone');
const seen = new Set();
const ordered = [];

preferredHandles.forEach((handle) => {
const match = flat.find((item) => normalizeText(item?.handle) === handle);
if (!match) return;
const key = `${normalizeText(match.handle)}|${normalizeText(match.model)}|${normalizeText(match.plastic)}`;
if (seen.has(key)) return;
seen.add(key);
ordered.push(match);
});

flat.forEach((item) => {
if (!item?.handle) return;
const key = `${normalizeText(item.handle)}|${normalizeText(item.model)}|${normalizeText(item.plastic)}`;
if (seen.has(key)) return;
seen.add(key);
ordered.push(item);
});

return ordered.slice(0, maxResults);
}

if (typeKey !== 'beginner_mix') {
if (typeKey === 'putter') {
return recommendationChoices(`putter_${stabilityKey}`, effectiveDistance, 'putter', {
useKey: 'approach',
stabilityKey
});
}
return recommendationChoices(`${typeKey}_${stabilityKey}`, effectiveDistance, typeKey, {
stabilityKey
});
}

const typeOrder = effectiveDistance === 'short'
? ['midrange', 'fairway', 'putter']
: ['midrange', 'fairway', 'putter', 'distance'];
const pools = typeOrder.map((candidateType) => {
if (candidateType === 'putter') {
return recommendationChoices(`putter_${stabilityKey}`, effectiveDistance, 'putter', {
useKey: 'approach',
stabilityKey
});
}
return recommendationChoices(`${candidateType}_${stabilityKey}`, effectiveDistance, candidateType, {
stabilityKey
});
});

const mixed = [];
const seen = new Set();
let round = 0;
while (mixed.length < maxResults && pools.some((pool) => round < pool.length)) {
pools.forEach((pool) => {
const item = pool[round];
if (!item || mixed.length >= maxResults) return;
const key = `${normalizeText(item.handle)}|${normalizeText(item.model)}|${normalizeText(item.plastic)}`;
if (seen.has(key)) return;
seen.add(key);
mixed.push(item);
});
round += 1;
}
return mixed;
};

const recommendationChoices = (zoneId, distanceKey, typeKey, preferences = {}) => {
let curatedList = [];
let fallbackItems = [];
const resultLimit = distanceKey === 'short' && !isBeginnerFocused ? Math.min(2, maxResults) : maxResults;

let curatedRole = false;

if (typeKey === 'putter' && preferences.useKey === 'putting') {
const dedicatedPutting = Array.isArray(curated.putter_putting) ? curated.putter_putting : [];

if (dedicatedPutting.length) {
curatedRole = true;
curatedList = dedicatedPutting.map((item) => ({ ...item, finderZone: 'putter_putting' }));
fallbackItems = [];
} else {
['putter_neutral', 'putter_understable', 'putter_overstable'].forEach((zone) => {
if (Array.isArray(curated[zone])) {
curatedList.push(...curated[zone].map((item) => ({ ...item, finderZone: zone })));
}
if (Array.isArray(FALLBACK_RECOMMENDATIONS[zone])) {
fallbackItems.push(...FALLBACK_RECOMMENDATIONS[zone].map((item) => ({ ...item, finderZone: zone })));
}
});
}
} else if (typeKey === 'putter' && preferences.useKey === 'throwing') {
curatedRole = true;
const throwingZone = `putter_throwing_${preferences.stabilityKey || 'neutral'}`;
curatedList = Array.isArray(curated[throwingZone])
? curated[throwingZone].map((item) => ({ ...item, finderZone: throwingZone }))
: [];
fallbackItems = Array.isArray(FALLBACK_RECOMMENDATIONS[throwingZone])
? FALLBACK_RECOMMENDATIONS[throwingZone].map((item) => ({ ...item, finderZone: throwingZone }))
: [];
} else if (typeKey === 'putter' && preferences.useKey === 'both') {
curatedRole = true;
const stability = preferences.stabilityKey || 'neutral';
const throwingZone = `putter_throwing_${stability}`;
const approachZone = `putter_${stability}`;
[throwingZone, approachZone].forEach((zone) => {
if (Array.isArray(curated[zone])) {
curatedList.push(...curated[zone].map((item) => ({ ...item, finderZone: zone })));
}
if (Array.isArray(FALLBACK_RECOMMENDATIONS[zone])) {
fallbackItems.push(...FALLBACK_RECOMMENDATIONS[zone].map((item) => ({ ...item, finderZone: zone })));
}
});
} else {
if (typeKey === 'putter' && preferences.useKey === 'approach') curatedRole = true;
curatedList = Array.isArray(curated[zoneId])
? curated[zoneId].map((item) => ({ ...item, finderZone: zoneId }))
: [];
fallbackItems = Array.isArray(FALLBACK_RECOMMENDATIONS[zoneId])
? FALLBACK_RECOMMENDATIONS[zoneId].map((item) => ({ ...item, finderZone: zoneId }))
: [];
}

const fallbackList = fallbackItems.map((item) => ({
...item,
flight: { speed: item.flight[0], glide: item.flight[1], turn: item.flight[2], fade: item.flight[3] },
variants: [],
loaded: false,
available: true,
bundleSave: false,
customReason: '',
discFinderUse: [],
rimType: '',
discHeight: '',
stability: '',
priceDisplay: '',
image: '',
productTitle: item.model,
source: 'fallback'
}));

const curatedSorted = sortByDistance(curatedList, distanceKey, typeKey);
const fallbackSorted = sortByDistance(fallbackList, distanceKey, typeKey);
const combined = [];
const seen = new Set();

[...curatedSorted, ...fallbackSorted].forEach((item) => {
if (!item || !item.handle) return;
const key = `${normalizeText(item.handle)}|${normalizeText(item.model)}|${normalizeText(item.plastic)}`;
if (seen.has(key)) return;
seen.add(key);
combined.push(item);
});

if (isGoalFocused && typeKey === focusedTypeKey) {
const focusedCandidates = curatedSorted.length ? curatedSorted : fallbackSorted;
return prioritizeFocusedCandidates(focusedCandidates, distanceKey, typeKey, preferences.goalKey || '').slice(0, resultLimit);
}

if (typeKey !== 'putter') return combined.slice(0, resultLimit);

return prioritizePutterCandidates(combined, { ...preferences, curatedRole }).slice(0, resultLimit);
};

const hydrateRecommendation = async (recommendation) => {
if (!recommendation || recommendation.loaded !== false || !recommendation.handle) return recommendation;
if (recommendation.loadingPromise) return recommendation.loadingPromise;

const productUrl = `${shopRoot()}products/${encodeURIComponent(recommendation.handle)}.js`;
recommendation.loadingPromise = window.fetch(productUrl, { headers: { Accept: 'application/json' } })
.then((response) => {
if (!response.ok) throw new Error(t.recommendationError);
return response.json();
})
.then((product) => {
const productImage = normalizeImageUrl(product.featured_image)
|| (Array.isArray(product.images) ? normalizeImageUrl(product.images[0]) : '');
const variants = (Array.isArray(product.variants) ? product.variants : [])
.filter((variant) => variant && variant.available)
.map((variant) => ({
id: variant.id,
title: String(variant.title || '').replace(/ \/ /g, ' - '),
priceDisplay: formatMoney(variant.price),
image: normalizeImageUrl(variant.featured_image)
|| normalizeImageUrl(variant.featured_media && variant.featured_media.preview_image)
|| productImage
}));

recommendation.productTitle = product.title || recommendation.model;
recommendation.url = `${shopRoot()}products/${encodeURIComponent(product.handle || recommendation.handle)}`;
recommendation.image = productImage || recommendation.image || '';
recommendation.priceDisplay = product.price_varies
? `${formatMoney(product.price_min)} - ${formatMoney(product.price_max)}`
: formatMoney(product.price);
const productTags = Array.isArray(product.tags)
? product.tags
: String(product.tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
const bundleSaveFromProduct = productTags.some((tag) => normalizeText(tag) === 'bundle & save');

recommendation.available = variants.length > 0;
recommendation.bundleSave = recommendation.bundleSave === true || bundleSaveFromProduct;
recommendation.variants = variants;
recommendation.loaded = true;
recommendation.loadingPromise = null;
return recommendation;
})
.catch((error) => {
recommendation.loadingPromise = null;
throw error;
});

return recommendation.loadingPromise;
};

const whyCopy = (recommendation) => {
const customReason = String(recommendation?.customReason || '').trim();
if (customReason) return customReason;
if (isBeginnerFocused && (currentFlightKey === 'not_sure' || currentTypeKey() === 'beginner_mix')) {
return t.whyBeginnerDefault || t.whyUnderstable || '';
}
if (isEasyLaunchFocused) {
const goalKey = currentGoalKey();
if (goalKey === 'easy') return t.whyEasyLaunchEasy || '';
if (goalKey === 'controlled') return t.whyEasyLaunchControl || '';
if (goalKey === 'maximum') return t.whyEasyLaunchDistance || '';
if (goalKey === 'wind') return t.whyEasyLaunchStepup || '';
}
if (isGoalFocused) {
const goalKey = currentGoalKey();
if (focusedTypeKey === 'fairway') {
if (goalKey === 'easy') return t.whyFairwayGoalEasy || t.whyUnderstable || '';
if (goalKey === 'maximum') return t.whyFairwayGoalShape || t.whyUnderstable || '';
if (goalKey === 'controlled') return t.whyFairwayGoalControlled || t.whyStraight || '';
if (goalKey === 'wind') return t.whyFairwayGoalWind || t.whyOverstable || '';
}
if (focusedTypeKey === 'midrange') {
if (goalKey === 'easy') return t.whyMidrangeGoalEasy || t.whyUnderstable || '';
if (goalKey === 'maximum') return t.whyMidrangeGoalShape || t.whyStraight || '';
if (goalKey === 'controlled') return t.whyMidrangeGoalControlled || t.whyStraight || '';
if (goalKey === 'wind') return t.whyMidrangeGoalWind || t.whyOverstable || '';
}
if (goalKey === 'easy') return t.whyGoalEasy || t.whyUnderstable || '';
if (goalKey === 'maximum') return t.whyGoalMaximum || t.whyStraight || '';
if (goalKey === 'controlled') return t.whyGoalControlled || t.whyStraight || '';
if (goalKey === 'wind') return t.whyGoalWind || t.whyOverstable || '';
}
const flightKey = currentFlightKey || normalizeText(recommendation?.stability);
if (flightKey === 'understable') return t.whyUnderstable || '';
if (flightKey === 'overstable') return t.whyOverstable || '';
return t.whyStraight || '';
};

const profileDisplay = (value) => {
const key = normalizeText(value);
if (key === 'low profile') return t.profileLow || value || '';
if (key === 'medium profile' || key === 'medium deep') return t.profileMedium || value || '';
if (key === 'deep rim') return t.profileDeep || value || '';
return value || '';
};

const rimDisplay = (value) => {
const key = normalizeText(value);
if (key === 'beadless') return t.rimBeadless || value || '';
if (key === 'beaded') return t.rimBeaded || value || '';
return value || '';
};

const createFlight = (recommendation) => {
const values = [
recommendation?.flight?.speed,
recommendation?.flight?.glide,
recommendation?.flight?.turn,
recommendation?.flight?.fade
];
if (values.every((value) => value === '' || value === null || value === undefined)) return null;
const flightNumbers = document.createElement('div');
flightNumbers.className = 'l64-disc-finder-v2__flight';
values.forEach((value) => {
const span = document.createElement('span');
span.textContent = value === '' || value === null || value === undefined ? '–' : String(value);
flightNumbers.append(span);
});
return flightNumbers;
};

const createPutterSpecs = (recommendation) => {
if (currentTypeKey() !== 'putter') return null;
const profileValue = profileDisplay(recommendation?.discHeight);
const rimValue = rimDisplay(recommendation?.rimType);
if (!profileValue && !rimValue) return null;

const specs = document.createElement('div');
specs.className = 'l64-disc-finder-v2__putter-specs';

const addSpec = (labelText, valueText) => {
if (!valueText) return;
const item = document.createElement('span');
item.className = 'l64-disc-finder-v2__putter-spec';
const label = document.createElement('strong');
label.textContent = labelText || '';
const value = document.createElement('span');
value.textContent = valueText;
item.append(label, value);
specs.append(item);
};

addSpec(t.profileLabel, profileValue);
addSpec(t.rimLabel, rimValue);
return specs.childElementCount ? specs : null;
};

const renderPrimary = (recommendation, index) => {
primaryCard.replaceChildren();
currentChoiceIndex = index;

if (!recommendation) {
const empty = document.createElement('div');
empty.className = 'l64-disc-finder-v2__empty';
empty.textContent = t.noRecommendations || '';
primaryCard.append(empty);
return;
}

const card = document.createElement('div');
card.className = 'l64-disc-finder-v2__primary-card';
card.dataset.selectedVariantId = '';
card.dataset.selectedVariantTitle = '';
card.dataset.quantity = '1';

const media = document.createElement('div');
media.className = 'l64-disc-finder-v2__primary-media';
if (recommendation.image) {
const image = document.createElement('img');
image.className = 'l64-disc-finder-v2__primary-image';
image.src = recommendation.image;
image.alt = recommendation.productTitle || recommendation.model || '';
image.loading = 'lazy';
image.width = 320;
image.height = 320;
image.dataset.primaryImage = '';
media.append(image);
}

const content = document.createElement('div');
content.className = 'l64-disc-finder-v2__primary-content';

const title = document.createElement('h3');
title.className = 'l64-disc-finder-v2__product-title';
const titleLink = document.createElement('a');
titleLink.href = recommendation.url || '#';
titleLink.textContent = recommendation.model || recommendation.productTitle || '';
title.append(titleLink);

const plastic = document.createElement('div');
plastic.className = 'l64-disc-finder-v2__product-plastic';
plastic.textContent = recommendation.productTitle && recommendation.productTitle !== recommendation.model
? recommendation.productTitle
: '';

const price = document.createElement('div');
price.className = 'l64-disc-finder-v2__price';
price.dataset.primaryPrice = '';
price.textContent = recommendation.priceDisplay || '';

content.append(title);
if (plastic.textContent) content.append(plastic);
if (price.textContent) content.append(price);

const flightNumbers = createFlight(recommendation);
if (flightNumbers) content.append(flightNumbers);
const putterSpecs = createPutterSpecs(recommendation);
if (putterSpecs) content.append(putterSpecs);

const why = document.createElement('div');
why.className = 'l64-disc-finder-v2__why';
const whyTitle = document.createElement('strong');
whyTitle.textContent = t.whyTitle || '';
const whyText = document.createElement('p');
whyText.textContent = whyCopy(recommendation);
why.append(whyTitle, whyText);
content.append(why);

const isBundleSavePutter = currentTypeKey() === 'putter' && recommendation.bundleSave === true;
if (isBundleSavePutter) {
const promo = document.createElement('div');
promo.className = 'l64-disc-finder-v2__bundle-promo';

const heading = document.createElement('div');
heading.className = 'l64-disc-finder-v2__bundle-heading';
const icon = document.createElement('span');
icon.className = 'l64-disc-finder-v2__bundle-icon';
icon.setAttribute('aria-hidden', 'true');
icon.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 13 11 22 2 13V4h9l9 9Z"></path><circle cx="7.5" cy="9.5" r="1.25"></circle></svg>';
const headingText = document.createElement('span');
headingText.textContent = t.bundleSaveTitle || '';
heading.append(icon, headingText);

const copy = document.createElement('p');
copy.className = 'l64-disc-finder-v2__bundle-copy';
copy.textContent = t.bundleSaveText || '';
promo.append(heading, copy);

if (bundleSaveUrl) {
const link = document.createElement('a');
link.className = 'l64-disc-finder-v2__bundle-link';
link.href = bundleSaveUrl;
link.textContent = t.bundleSaveLink || '';
promo.append(link);
}

content.append(promo);
}

const variants = Array.isArray(recommendation.variants) ? recommendation.variants : [];
if (variants.length > 1) {
const wrap = document.createElement('div');
wrap.className = 'l64-disc-finder-v2__variant-wrap';
const label = document.createElement('label');
label.className = 'l64-disc-finder-v2__variant-label';
label.textContent = t.colorWeight || '';
const select = document.createElement('select');
select.dataset.primaryVariant = 'true';
select.setAttribute('aria-label', t.colorWeight || '');
const placeholder = document.createElement('option');
placeholder.value = '';
placeholder.textContent = t.chooseColorWeight || t.colorWeight || '';
select.append(placeholder);
variants.forEach((variant) => {
const option = document.createElement('option');
option.value = String(variant.id);
option.textContent = variant.title || '';
option.dataset.image = variant.image || '';
option.dataset.priceDisplay = variant.priceDisplay || '';
select.append(option);
});
const chevron = document.createElement('span');
chevron.className = 'l64-disc-finder-v2__variant-chevron';
chevron.setAttribute('aria-hidden', 'true');
wrap.append(label, select, chevron);
content.append(wrap);
} else if (variants.length === 1) {
card.dataset.selectedVariantId = String(variants[0].id);
card.dataset.selectedVariantTitle = variants[0].title || '';
}

if (isBundleSavePutter) {
const quantityWrap = document.createElement('div');
quantityWrap.className = 'l64-disc-finder-v2__quantity-wrap';
const quantityLabel = document.createElement('label');
quantityLabel.className = 'l64-disc-finder-v2__quantity-label';
quantityLabel.textContent = t.quantity || '';

const quantityControl = document.createElement('div');
quantityControl.className = 'l64-disc-finder-v2__quantity-control';

const minus = document.createElement('button');
minus.type = 'button';
minus.dataset.quantityStep = '-1';
minus.setAttribute('aria-label', t.decreaseQuantity || t.quantity || '');
minus.textContent = '−';

const quantityInput = document.createElement('input');
quantityInput.type = 'number';
quantityInput.min = '1';
quantityInput.max = '50';
quantityInput.step = '1';
quantityInput.value = '1';
quantityInput.inputMode = 'numeric';
quantityInput.dataset.primaryQuantity = 'true';
quantityInput.id = `DiscFinderQuantity-${root.id}-${index}`;
quantityInput.setAttribute('aria-label', t.quantity || '');
quantityLabel.htmlFor = quantityInput.id;

const plus = document.createElement('button');
plus.type = 'button';
plus.dataset.quantityStep = '1';
plus.setAttribute('aria-label', t.increaseQuantity || t.quantity || '');
plus.textContent = '+';

quantityControl.append(minus, quantityInput, plus);
quantityWrap.append(quantityLabel, quantityControl);
content.append(quantityWrap);
}

const actions = document.createElement('div');
actions.className = 'l64-disc-finder-v2__actions';

const productLink = document.createElement('a');
productLink.className = 'l64-disc-finder-v2__secondary-button';
productLink.href = recommendation.url || '#';
productLink.textContent = t.viewProduct || '';

const addButton = document.createElement('button');
addButton.type = 'button';
addButton.className = 'l64-disc-finder-v2__primary-button';
addButton.dataset.addPrimary = 'true';
addButton.textContent = recommendation.available ? t.addToCart : t.soldOut;
addButton.disabled = !recommendation.available || variants.length === 0 || variants.length > 1;

actions.append(productLink, addButton);
content.append(actions);
card.append(media, content);
primaryCard.append(card);

track('recommendation_viewed', {
zone: currentZone,
model: recommendation.model || '',
plastic: recommendation.plastic || '',
source: recommendation.source || 'fallback',
position: index + 1
}, 'Disc Finder - Recommendation Viewed');
};

const renderAlternatives = () => {
alternatives.replaceChildren();
const otherChoices = currentChoices
.map((choice, index) => ({ choice, index }))
.filter((entry) => entry.index !== currentChoiceIndex);

alternativesWrap.hidden = otherChoices.length === 0;
if (!otherChoices.length) return;

otherChoices.forEach(({ choice, index }) => {
const button = document.createElement('button');
button.type = 'button';
button.className = 'l64-disc-finder-v2__alternative';
button.dataset.alternativeIndex = String(index);

const imageWrap = document.createElement('span');
imageWrap.className = 'l64-disc-finder-v2__alternative-image-wrap';
if (choice.image) {
const image = document.createElement('img');
image.className = 'l64-disc-finder-v2__alternative-image';
image.src = choice.image;
image.alt = '';
image.loading = 'lazy';
image.width = 88;
image.height = 88;
imageWrap.append(image);
}

const copy = document.createElement('span');
const name = document.createElement('span');
name.className = 'l64-disc-finder-v2__alternative-name';
name.textContent = choice.model || choice.productTitle || '';
const meta = document.createElement('span');
meta.className = 'l64-disc-finder-v2__alternative-meta';
meta.textContent = choice.plastic || '';
const numbers = [choice?.flight?.speed, choice?.flight?.glide, choice?.flight?.turn, choice?.flight?.fade]
.filter((value) => value !== '' && value !== null && value !== undefined);
const flightLine = document.createElement('span');
flightLine.className = 'l64-disc-finder-v2__alternative-flight';
flightLine.textContent = numbers.length === 4 ? numbers.join(' / ') : '';
const putterMeta = document.createElement('span');
putterMeta.className = 'l64-disc-finder-v2__alternative-flight';
if (currentTypeKey() === 'putter') {
putterMeta.textContent = [profileDisplay(choice.discHeight), rimDisplay(choice.rimType)].filter(Boolean).join(' · ');
}
copy.append(name);
if (meta.textContent) copy.append(meta);
if (flightLine.textContent) copy.append(flightLine);
if (putterMeta.textContent) copy.append(putterMeta);

button.append(imageWrap, copy);
alternatives.append(button);
});
};

const renderChoice = async (index, trackChange = false) => {
const recommendation = currentChoices[index];
if (!recommendation) return;
currentChoiceIndex = index;
loading.hidden = false;
primaryCard.replaceChildren();

try {
await hydrateRecommendation(recommendation);
} catch (error) {
loading.hidden = true;
const empty = document.createElement('div');
empty.className = 'l64-disc-finder-v2__empty';
empty.textContent = t.recommendationError || '';
primaryCard.replaceChildren(empty);
renderAlternatives();
return;
}

loading.hidden = true;
renderPrimary(recommendation, index);
renderAlternatives();

if (trackChange) {
track('recommendation_selected', {
zone: currentZone,
model: recommendation.model || '',
plastic: recommendation.plastic || '',
source: recommendation.source || 'fallback',
position: index + 1
}, 'Disc Finder - Recommendation Selected');
}
};

const updatePrimaryVariant = (select) => {
const card = select.closest('.l64-disc-finder-v2__primary-card');
if (!card) return;
const option = select.options[select.selectedIndex];
const image = card.querySelector('[data-primary-image]');
const price = card.querySelector('[data-primary-price]');
const addButton = card.querySelector('[data-add-primary]');

card.dataset.selectedVariantId = option && option.value ? option.value : '';
card.dataset.selectedVariantTitle = option && option.value ? option.textContent : '';
if (addButton) addButton.disabled = !option || !option.value;
if (option && option.value && option.dataset.image && image) image.src = option.dataset.image;
if (option && option.value && option.dataset.priceDisplay && price) price.textContent = option.dataset.priceDisplay;

if (option && option.value) {
const recommendation = currentChoices[currentChoiceIndex];
track('variant_selected', {
zone: currentZone,
model: recommendation?.model || '',
plastic: recommendation?.plastic || '',
variant_id: option.value,
variant_title: option.textContent || ''
}, 'Disc Finder - Variant Selected');
}
};

const addPrimaryToCart = async (button) => {
const card = button.closest('.l64-disc-finder-v2__primary-card');
const recommendation = currentChoices[currentChoiceIndex];
const variantId = card?.dataset.selectedVariantId || '';
const quantityInput = card?.querySelector('[data-primary-quantity]');
const quantity = Math.min(50, Math.max(1, Number.parseInt(quantityInput?.value || card?.dataset.quantity || '1', 10) || 1));
if (!card || !recommendation || !variantId) return;

if (quantityInput) quantityInput.value = String(quantity);
card.dataset.quantity = String(quantity);

const originalText = button.textContent;
button.disabled = true;
button.textContent = t.adding || originalText;

try {
const response = await window.fetch(`${shopRoot()}cart/add.js`, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
});

if (!response.ok) {
const payload = await response.json().catch(() => ({}));
throw new Error(payload.description || payload.message || t.cartError);
}

let cart = null;
try {
const cartResponse = await window.fetch(`${shopRoot()}cart.js`, { headers: { Accept: 'application/json' } });
if (cartResponse.ok) cart = await cartResponse.json();
} catch (error) {
}

const items = [{ id: Number(variantId), quantity }];
if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
document.dispatchEvent(new CustomEvent('cart:refresh'));
document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { items, cart } }));
document.dispatchEvent(new CustomEvent('product:added', { detail: { items, cart } }));

button.textContent = t.added || originalText;
announce(`${t.added || ''} ${recommendation.model || ''}`.trim());
track('added_to_cart', {
zone: currentZone,
model: recommendation.model || '',
plastic: recommendation.plastic || '',
variant_id: String(variantId),
variant_title: card.dataset.selectedVariantTitle || '',
quantity,
position: currentChoiceIndex + 1
}, 'Disc Finder - Added to Cart');

window.setTimeout(() => {
button.disabled = false;
button.textContent = originalText;
}, 1500);
} catch (error) {
button.textContent = t.cartError || originalText;
announce(error.message || t.cartError || '');
window.setTimeout(() => {
button.disabled = false;
button.textContent = originalText;
}, 1800);
}
};

const bundleRecommendationKey = () => {
if (!bundleData?.enabled) return '';

const distanceKey = currentDistanceKey();
const goalKey = currentGoalKey();

if (finderMode === 'beginner') {
if (distanceKey === 'short') return 'new_player';
if (distanceKey === 'medium') return 'beginner_next';
if (distanceKey === 'long') return 'premium';
return '';
}

if (finderMode === 'easy_launch') {
if (goalKey === 'easy') return 'new_player';
if (goalKey === 'maximum' || goalKey === 'controlled') return 'easy_launch';
if (goalKey === 'wind') return 'developing';
return '';
}

if (finderMode === 'general') {
if (distanceKey === 'short') return 'new_player';
if (distanceKey === 'long') return 'experienced';
if (distanceKey === 'medium') return 'developing';
}

return '';
};

const renderBundleRecommendation = () => {
if (!bundleRecommendation) return;
bundleRecommendation.replaceChildren();
bundleRecommendation.hidden = true;

const key = bundleRecommendationKey();
const product = key ? bundleData?.products?.[key] : null;
if (!product || !product.handle || !product.title || !product.available) return;

const intro = document.createElement('div');
intro.className = 'l64-disc-finder-v2__bundle-intro';

const introTitle = document.createElement('p');
introTitle.className = 'l64-disc-finder-v2__bundle-intro-title';
introTitle.textContent = t.bundleReadyTitle || '';

const introCopy = document.createElement('p');
introCopy.className = 'l64-disc-finder-v2__bundle-intro-copy';
introCopy.textContent = t.bundleReadyText || '';
intro.append(introTitle, introCopy);

const card = document.createElement('article');
card.className = 'l64-disc-finder-v2__bundle-card';
card.dataset.bundleKey = key;

const imageLink = document.createElement('a');
imageLink.className = 'l64-disc-finder-v2__bundle-image-link';
imageLink.href = product.url || '#';
imageLink.dataset.bundleLink = 'true';
imageLink.setAttribute('aria-label', product.title || '');
if (product.image) {
const image = document.createElement('img');
image.className = 'l64-disc-finder-v2__bundle-image';
image.src = product.image;
image.alt = product.title || '';
image.loading = 'lazy';
image.width = 132;
image.height = 132;
imageLink.append(image);
}

const content = document.createElement('div');
content.className = 'l64-disc-finder-v2__bundle-content';

const title = document.createElement('h3');
title.className = 'l64-disc-finder-v2__bundle-title';
const titleLink = document.createElement('a');
titleLink.href = product.url || '#';
titleLink.dataset.bundleLink = 'true';
titleLink.textContent = product.title || '';
title.append(titleLink);
content.append(title);

if (product.subtitle) {
const subtitle = document.createElement('p');
subtitle.className = 'l64-disc-finder-v2__bundle-subtitle';
subtitle.textContent = product.subtitle;
content.append(subtitle);
}

if (product.idealPlayer) {
const bestFor = document.createElement('div');
bestFor.className = 'l64-disc-finder-v2__bundle-best-for';
const bestForLabel = document.createElement('span');
bestForLabel.className = 'l64-disc-finder-v2__bundle-best-for-label';
bestForLabel.textContent = t.bundleBestFor || '';
const bestForValue = document.createElement('span');
bestForValue.className = 'l64-disc-finder-v2__bundle-best-for-value';
bestForValue.textContent = product.idealPlayer;
bestFor.append(bestForLabel, bestForValue);
content.append(bestFor);
}

const price = Number(product.price || 0);
const compareAtPrice = Number(product.compareAtPrice || 0);
if (price > 0) {
const priceWrap = document.createElement('div');
priceWrap.className = 'l64-disc-finder-v2__bundle-price';
const currentPrice = document.createElement('span');
currentPrice.textContent = formatMoney(price);
priceWrap.append(currentPrice);
if (compareAtPrice > price) {
const comparePrice = document.createElement('span');
comparePrice.className = 'l64-disc-finder-v2__bundle-compare';
comparePrice.textContent = formatMoney(compareAtPrice);
priceWrap.append(comparePrice);
}
content.append(priceWrap);
}

const action = document.createElement('div');
action.className = 'l64-disc-finder-v2__bundle-action';

if (product.directAdd && product.variantId) {
const button = document.createElement('button');
button.type = 'button';
button.className = 'l64-disc-finder-v2__bundle-button';
button.dataset.bundleAdd = 'true';
button.dataset.bundleVariantId = String(product.variantId);
button.dataset.bundleTitle = product.title || '';
button.dataset.bundleKey = key;
button.textContent = t.addToCart || '';
action.append(button);
} else {
const link = document.createElement('a');
link.className = 'l64-disc-finder-v2__bundle-button';
link.href = product.url || '#';
link.dataset.bundleLink = 'true';
link.dataset.bundleKey = key;
link.textContent = product.isEliteBundle ? (t.bundleCustomize || t.viewProduct || '') : (t.bundleView || t.viewProduct || '');
action.append(link);
}

card.append(imageLink, content, action);
bundleRecommendation.append(intro, card);
bundleRecommendation.hidden = false;

track('bundle_recommendation_viewed', {
bundle_key: key,
bundle_handle: product.handle || '',
bundle_title: product.title || '',
elite_bundle: Boolean(product.isEliteBundle),
direct_add: Boolean(product.directAdd)
}, 'Disc Finder - Bundle Recommendation Viewed');
};

const addBundleToCart = async (button) => {
const variantId = Number(button?.dataset.bundleVariantId || 0);
if (!variantId) return;

const originalText = button.textContent;
button.disabled = true;
button.textContent = t.adding || originalText;

try {
const response = await window.fetch(`${shopRoot()}cart/add.js`, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
});

if (!response.ok) {
const payload = await response.json().catch(() => ({}));
throw new Error(payload.description || payload.message || t.cartError);
}

let cart = null;
try {
const cartResponse = await window.fetch(`${shopRoot()}cart.js`, { headers: { Accept: 'application/json' } });
if (cartResponse.ok) cart = await cartResponse.json();
} catch (error) {
}

const items = [{ id: variantId, quantity: 1 }];
if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
document.dispatchEvent(new CustomEvent('cart:refresh'));
document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { items, cart } }));
document.dispatchEvent(new CustomEvent('product:added', { detail: { items, cart } }));

button.textContent = t.added || originalText;
announce(`${t.added || ''} ${button.dataset.bundleTitle || ''}`.trim());

track('bundle_added_to_cart', {
bundle_key: button.dataset.bundleKey || '',
bundle_title: button.dataset.bundleTitle || '',
variant_id: String(variantId)
}, 'Disc Finder - Bundle Added to Cart');

window.setTimeout(() => {
button.disabled = false;
button.textContent = originalText;
}, 1500);
} catch (error) {
button.textContent = t.cartError || originalText;
announce(error.message || t.cartError || '');
window.setTimeout(() => {
button.disabled = false;
button.textContent = originalText;
}, 1800);
}
};

const buildViewAllUrl = () => {
if (isEasyLaunchFocused) {
const goalKey = currentGoalKey();
const destination = goalKey === 'easy' ? zeroGravityUrl : easyToUseUrl;
if (!destination) return '#';
const url = new URL(destination, window.location.href);
return `${url.pathname}${url.search}`;
}
const selectedType = selectedOption(type);
const selectedFlight = selectedOption(flight);
const destination = selectedType?.dataset.url || '';
if (!destination) return '#';
const url = new URL(destination, window.location.href);
const filterKey = root.dataset.stabilityFilter;
const filterValue = selectedFlight?.dataset.filterValue || '';
const shouldFilterFlight = currentTypeKey() !== 'putter' || currentUseKey() !== 'putting';
if (filterKey && filterValue && shouldFilterFlight) url.searchParams.set(filterKey, filterValue);
return `${url.pathname}${url.search}`;
};

const summaryText = () => {
const distanceText = selectedOption(distance)?.textContent?.trim() || '';
const typeText = selectedOption(type)?.textContent?.trim() || '';
if (isEasyLaunchFocused) {
const goalText = selectedOption(goal)?.textContent?.trim() || '';
return [goalText, typeText].filter(Boolean).join(' · ');
}
if (isGoalFocused) {
const goalText = selectedOption(goal)?.textContent?.trim() || '';
const flightText = selectedOption(flight)?.textContent?.trim() || '';
return [distanceText, goalText, flightText].filter(Boolean).join(' · ');
}
if (isBeginnerFocused) {
const flightText = selectedOption(flight)?.textContent?.trim() || '';
return [distanceText, typeText, flightText].filter(Boolean).join(' · ');
}
if (currentTypeKey() !== 'putter') {
const flightText = selectedOption(flight)?.textContent?.trim() || '';
return [distanceText, typeText, flightText].filter(Boolean).join(' · ');
}

const useText = selectedOption(use)?.textContent?.trim() || '';
const profileText = profile.value !== 'any' ? selectedOption(profile)?.textContent?.trim() || '' : '';
const finalText = currentUseKey() === 'putting'
? (rim.value !== 'any' ? selectedOption(rim)?.textContent?.trim() || '' : '')
: selectedOption(flight)?.textContent?.trim() || '';
return [distanceText, isPuttFocused ? '' : typeText, useText, profileText, finalText].filter(Boolean).join(' · ');
};

const showResults = async () => {
const distanceKey = currentDistanceKey();
const typeKey = currentTypeKey();
const useKey = currentUseKey();
const goalKey = currentGoalKey();
const flightKey = currentFlightKeyValue();
const profileValue = currentProfileValue();
const rimValue = currentRimValue();

if (typeKey === 'catchplay') {
const destination = selectedOption(type)?.dataset.url || '';
if (destination) {
announce(t.catchPlayRedirect || '');
track('catch_play_opened', { distance: distanceKey }, 'Disc Finder - Catch & Play Opened');
window.location.assign(destination);
}
return;
}

const stabilityKey = flightKey === 'straight' ? 'neutral' : flightKey;
if (isEasyLaunchFocused) {
currentZone = `easy_launch_${goalKey}_${typeKey}`;
currentFlightKey = '';
currentChoices = easyLaunchRecommendationChoices(goalKey, typeKey);
} else if (isBeginnerFocused) {
currentZone = `beginner_${typeKey}_${flightKey || 'not_sure'}`;
currentFlightKey = flightKey;
currentChoices = beginnerRecommendationChoices(distanceKey, typeKey, flightKey);
} else {
if (typeKey === 'putter' && useKey === 'putting') {
currentZone = 'putter_putting';
} else if (typeKey === 'putter' && useKey === 'throwing') {
currentZone = `putter_throwing_${stabilityKey}`;
} else if (typeKey === 'putter' && useKey === 'both') {
currentZone = `putter_both_${stabilityKey}`;
} else {
currentZone = `${typeKey}_${stabilityKey}`;
}
currentFlightKey = flightKey;
currentChoices = recommendationChoices(currentZone, distanceKey, typeKey, {
useKey,
goalKey,
stabilityKey,
profileValue,
rimValue: useKey === 'putting' ? rimValue : ''
});
}
currentChoiceIndex = 0;

const summary = summaryText();
if (resultContext) resultContext.textContent = summary;
viewAll.href = buildViewAllUrl();
results.hidden = false;
root.classList.add('has-results');
root.classList.remove('is-editing');
loading.hidden = false;
primaryCard.replaceChildren();
alternatives.replaceChildren();
alternativesWrap.hidden = true;
if (bundleRecommendation) {
bundleRecommendation.hidden = true;
bundleRecommendation.replaceChildren();
}

track('submitted', {
distance: distanceKey,
disc_type: typeKey,
mode: finderMode,
use: useKey,
goal: goalKey,
profile: profileValue,
rim: useKey === 'putting' ? rimValue : '',
flight: flightKey,
zone: currentZone,
recommendation_count: currentChoices.length
}, 'Disc Finder - Submitted');

if (!currentChoices.length) {
loading.hidden = true;
renderPrimary(null, 0);
} else {
await Promise.allSettled(currentChoices.map((choice) => hydrateRecommendation(choice)));
const usable = currentChoices.filter((choice) => choice.loaded !== false && choice.handle);
currentChoices = usable.length ? usable : currentChoices;
await renderChoice(0, false);
}

renderBundleRecommendation();

if (window.matchMedia('(max-width: 768px)').matches) {
window.setTimeout(() => results.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
}
};

const resetFinder = () => {
distance.selectedIndex = 0;
if (isEasyLaunchFocused) {
resetEasyLaunchFields();
} else if (isGoalFocused) {
resetFocusedGoalFields();
} else if (isPuttFocused) {
resetFocusedPutterFields();
} else {
rebuildOptions(type, typePlaceholder, typeOptionBank, [], 'typeKey');
rebuildOptions(goal, goalPlaceholder, goalOptionBank, [], 'goalKey');
rebuildOptions(flight, flightPlaceholder, flightOptionBank, [], 'flightKey');
setAdvancedHidden();
type.disabled = true;
goal.disabled = true;
goalField.hidden = true;
flight.disabled = true;
flightField.hidden = false;
if (useStep) useStep.textContent = '3';
if (profileStep) profileStep.textContent = '4';
if (rimStep) rimStep.textContent = '5';
if (flightStep) flightStep.textContent = '3';
form.classList.remove('is-catch-play', 'is-putter', 'is-distance-focused', 'is-easy-launch');
}
results.hidden = true;
root.classList.remove('has-results', 'is-editing');
currentChoices = [];
currentChoiceIndex = 0;
currentZone = '';
currentFlightKey = '';
if (bundleRecommendation) {
bundleRecommendation.hidden = true;
bundleRecommendation.replaceChildren();
}
updateSubmit();
};

distance.addEventListener('change', isGoalFocused ? updateFocusedDistance : (isPuttFocused ? updateFocusedPutterDistance : updateTypeOptions));
type.addEventListener('change', isEasyLaunchFocused ? updateSubmit : updateFlightOptions);
goal.addEventListener('change', isEasyLaunchFocused ? updateEasyLaunchGoal : updateFocusedGoal);
use.addEventListener('change', updatePutterUse);
profile.addEventListener('change', updateSubmit);
rim.addEventListener('change', updateSubmit);
flight.addEventListener('change', updateSubmit);

form.addEventListener('submit', (event) => {
event.preventDefault();
if (submit.disabled) return;
showResults();
});

root.addEventListener('click', (event) => {
const change = event.target.closest('[data-change-choices]');
if (change) {
root.classList.add('is-editing');
results.hidden = true;
window.requestAnimationFrame(() => {
form.scrollIntoView({ behavior: 'smooth', block: 'start' });
window.setTimeout(() => {
const focusTarget = [distance, goal, type, use, profile, rim, flight].find((field) => field && !field.disabled && !field.closest('[hidden]'));
focusTarget?.focus({ preventScroll: true });
}, 420);
});
track('choices_edit_started', {
distance: currentDistanceKey(),
disc_type: currentTypeKey(),
mode: finderMode,
use: currentUseKey(),
goal: currentGoalKey(),
profile: currentProfileValue(),
rim: currentRimValue(),
flight: currentFlightKeyValue()
}, 'Disc Finder - Choices Edit Started');
return;
}

const quantityButton = event.target.closest('[data-quantity-step]');
if (quantityButton) {
const card = quantityButton.closest('.l64-disc-finder-v2__primary-card');
const input = card?.querySelector('[data-primary-quantity]');
if (!card || !input) return;
const step = Number.parseInt(quantityButton.dataset.quantityStep || '0', 10) || 0;
const current = Number.parseInt(input.value || '1', 10) || 1;
const next = Math.min(50, Math.max(1, current + step));
input.value = String(next);
card.dataset.quantity = String(next);
return;
}

const bundleAdd = event.target.closest('[data-bundle-add]');
if (bundleAdd) {
addBundleToCart(bundleAdd);
return;
}

const bundleLink = event.target.closest('[data-bundle-link]');
if (bundleLink) {
track('bundle_recommendation_clicked', {
bundle_key: bundleLink.dataset.bundleKey || bundleLink.closest('[data-bundle-key]')?.dataset.bundleKey || '',
href: bundleLink.getAttribute('href') || ''
}, 'Disc Finder - Bundle Recommendation Clicked');
}

const alternative = event.target.closest('[data-alternative-index]');
if (alternative) {
const index = Number(alternative.dataset.alternativeIndex);
if (Number.isInteger(index) && currentChoices[index]) renderChoice(index, true);
return;
}

const addButton = event.target.closest('[data-add-primary]');
if (addButton) addPrimaryToCart(addButton);
});

root.addEventListener('change', (event) => {
const quantityInput = event.target.closest('[data-primary-quantity]');
if (quantityInput) {
const card = quantityInput.closest('.l64-disc-finder-v2__primary-card');
const quantity = Math.min(50, Math.max(1, Number.parseInt(quantityInput.value || '1', 10) || 1));
quantityInput.value = String(quantity);
if (card) card.dataset.quantity = String(quantity);
return;
}

const select = event.target.closest('[data-primary-variant]');
if (select) updatePrimaryVariant(select);
});

viewAll.addEventListener('click', () => {
track('view_all_clicked', {
zone: currentZone,
href: viewAll.getAttribute('href') || ''
}, 'Disc Finder - View All Clicked');
});

root.addEventListener('l64:disc-finder-v2:reset', resetFinder);
resetFinder();
};

const initWithin = (container) => {
if (container.matches && container.matches('[data-disc-finder-v2]')) initFinder(container);
container.querySelectorAll?.('[data-disc-finder-v2]').forEach(initFinder);
};

initWithin(document);
document.addEventListener('shopify:section:load', (event) => initWithin(event.target));

window.addEventListener('pageshow', (event) => {
const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
const isHistoryReturn = event.persisted || navigation?.type === 'back_forward';
if (!isHistoryReturn) return;
document.querySelectorAll('[data-disc-finder-v2]').forEach((root) => {
root.dispatchEvent(new CustomEvent('l64:disc-finder-v2:reset'));
});
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["l64-card-quick-add"] && !Shopify.designMode) return;
  try {
    
/* LATITUDE 64 - CARD SWATCH PREVIEW V3.2 */
(function () {
  if (window.L64CardSwatchPreview) return;
  window.L64CardSwatchPreview = true;

  function start() {
    var first = document.getElementById('l64-card-qa-config');
    if (!first) return;

    function cfg() {
      var el = document.getElementById('l64-card-qa-config');
      return {
        info: !!el && el.getAttribute('data-qa') === 'true',
        sw: !!el && el.getAttribute('data-sw') === 'true'
      };
    }

    var SV = first.getAttribute('data-locale') === 'sv';
    var L = SV
      ? { color: 'Färg', weights: 'Vikter i lager:', inStock: 'I lager:', soldOut: 'Slutsåld i den här färgen' }
      : { color: 'Colour', weights: 'Weights in stock:', inStock: 'In stock:', soldOut: 'Sold out in this colour' };

    document.documentElement.setAttribute('data-l64-swatch-preview', '3.2');
    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
    var CARD = '.grid-product[data-product-handle]';
    var SWATCH = '.l64-swatches--interactive [data-l64-color]';
    var cache = {};

    function load(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('load'); return r.json(); })
          .catch(function (e) { delete cache[handle]; throw e; });
      }
      return cache[handle];
    }

    function optNames(p) {
      return (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    }

    function colorIndex(p, card) {
      var names = optNames(p);
      for (var i = 0; i < names.length; i++) {
        if (/colou?r|f\u00e4rg/i.test(names[i])) return i;
      }
      var sw = card.querySelector('[data-l64-color]');
      if (sw) {
        var c = sw.getAttribute('data-l64-color');
        for (var j = 0; j < names.length; j++) {
          if (p.variants.some(function (v) { return v.options[j] === c; })) return j;
        }
      }
      return -1;
    }

    function num(s) { var n = parseFloat(String(s).replace(',', '.')); return isNaN(n) ? 0 : n; }
    function linkOf(card) { return card.querySelector('a.grid-product__link'); }

    function expand(card) {
      var row = card.querySelector('.l64-swatches--interactive');
      if (!row || row.classList.contains('is-expanded') || !row.querySelector('.l64-grid-color-swatch--extra')) return false;
      row.classList.add('is-expanded');
      var more = row.querySelector('.l64-grid-color-more');
      if (more) {
        var rest = parseInt(more.getAttribute('data-l64-rest') || '0', 10);
        if (rest > 0) {
          more.textContent = '+' + rest;
        } else {
          more.style.display = 'none';
          more.removeAttribute('tabindex');
          more.setAttribute('aria-hidden', 'true');
        }
      }
      return true;
    }
    function abs(url) { return url && url.indexOf('//') === 0 ? 'https:' + url : url; }

    function colorImage(p, ci, color) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (v.options[ci] === color && v.featured_image) return v.featured_image.src || v.featured_image;
      }
      return null;
    }

    function firstVariant(p, ci, color) {
      var list = p.variants.filter(function (v) { return v.options[ci] === color; });
      for (var i = 0; i < list.length; i++) if (list[i].available) return list[i];
      return list[0] || null;
    }

    function stockText(p, ci, color) {
      var names = optNames(p);
      if (names.length < 2) return '';
      var wi = ci === 0 ? 1 : 0;
      var seen = {}, vals = [];
      p.variants.forEach(function (v) {
        if (v.options[ci] !== color || !v.available) return;
        var val = v.options[wi];
        if (!seen[val]) { seen[val] = true; vals.push(val); }
      });
      if (!vals.length) return L.soldOut;
      vals.sort(function (a, b) { return num(a) - num(b); });
      var label = /weight|vikt/i.test(names[wi] || '') ? L.weights : L.inStock;
      return label + ' ' + vals.join(', ');
    }

    /* ---------- prepare a card on first hover/focus (desktop only) ---------- */
    function prepare(card) {
      if (!FINE.matches || !cfg().sw || card.getAttribute('data-l64-prep')) return;
      card.setAttribute('data-l64-prep', '1');
      var sw = card.querySelector('a.grid-product__link .l64-grid-color-swatches');
      if (!sw) return;
      var link = sw.closest('a.grid-product__link');
      link.parentNode.insertBefore(sw, link.nextSibling);
      sw.classList.add('l64-swatches--interactive');
      sw.setAttribute('role', 'group');
      var items = sw.querySelectorAll('.l64-grid-color-swatch');
      for (var i = 0; i < items.length; i++) {
        var s = items[i], name = s.getAttribute('title') || '';
        s.setAttribute('data-l64-color', name);
        s.removeAttribute('aria-hidden');
        s.setAttribute('role', 'button');
        s.setAttribute('tabindex', '0');
        s.setAttribute('aria-pressed', 'false');
        s.setAttribute('aria-label', L.color + ': ' + name);
      }
      var more = sw.querySelector('.l64-grid-color-more');
      if (more) {
        more.removeAttribute('aria-hidden');
        more.setAttribute('role', 'button');
        more.setAttribute('tabindex', '0');
      }
    }

    /* ---------- card image ---------- */
    function cardImg(card) {
      return card.querySelector('.grid-product__image-mask .grid__image-ratio img, .grid-product__image-mask .image-wrap img');
    }

    function setCardImage(card, url) {
      var img = cardImg(card);
      if (!img) return;
      if (!img.hasAttribute('data-l64-orig-src')) {
        img.setAttribute('data-l64-orig-src', img.getAttribute('src') || '');
        img.setAttribute('data-l64-orig-srcset', img.getAttribute('srcset') || '');
      }
      if (!url) {
        var os = img.getAttribute('data-l64-orig-srcset');
        if (os) img.setAttribute('srcset', os); else img.removeAttribute('srcset');
        img.setAttribute('src', img.getAttribute('data-l64-orig-src'));
        return;
      }
      var u = abs(url), sep = u.indexOf('?') > -1 ? '&' : '?';
      img.setAttribute('srcset', [360, 540, 720, 900, 1080].map(function (w) { return u + sep + 'width=' + w + ' ' + w + 'w'; }).join(', '));
      img.setAttribute('src', u + sep + 'width=720');
    }

    /* ---------- info strip ---------- */
    function infoEl(card) {
      var mask = card.querySelector('.grid-product__image-mask');
      if (!mask) return null;
      var box = mask.querySelector('.l64-sw-info');
      if (!box) {
        box = document.createElement('div');
        box.className = 'l64-sw-info';
        box.setAttribute('aria-live', 'polite');
        var c = document.createElement('span');
        c.className = 'l64-sw-info__color';
        var s = document.createElement('span');
        s.className = 'l64-sw-info__stock';
        box.appendChild(c);
        box.appendChild(s);
        mask.appendChild(box);
      }
      return box;
    }

    function showInfo(card, p, ci, color) {
      if (!cfg().info) return;
      var box = infoEl(card);
      if (!box) return;
      box.querySelector('.l64-sw-info__color').textContent = color;
      box.querySelector('.l64-sw-info__stock').textContent = stockText(p, ci, color);
      box.classList.add('is-visible');
    }

    function hideInfo(card) {
      var box = card.querySelector('.l64-sw-info');
      if (box) box.classList.remove('is-visible');
    }

    /* ---------- preview / select ---------- */
    function preview(card, color) {
      card._l64hover = color;
      load(card.getAttribute('data-product-handle')).then(function (p) {
        if (card._l64hover !== color) return;
        var ci = colorIndex(p, card);
        if (ci < 0) return;
        var url = colorImage(p, ci, color);
        if (url) {
          card.classList.add('l64-color-preview');
          setCardImage(card, url);
        }
        showInfo(card, p, ci, color);
      }).catch(function () {});
    }

    function endPreview(card) {
      card._l64hover = null;
      hideInfo(card);
      card.classList.remove('l64-color-preview');
      if (!card._l64chosen) { setCardImage(card, null); return; }
      load(card.getAttribute('data-product-handle')).then(function (p) {
        if (card._l64hover) return;
        setCardImage(card, colorImage(p, colorIndex(p, card), card._l64color));
      }).catch(function () {});
    }

    function select(card, color) {
      load(card.getAttribute('data-product-handle')).then(function (p) {
        var ci = colorIndex(p, card);
        if (ci < 0) return;
        card._l64color = color;
        card._l64chosen = true;
        var items = card.querySelectorAll(SWATCH);
        for (var i = 0; i < items.length; i++) {
          var on = items[i].getAttribute('data-l64-color') === color;
          items[i].classList.toggle('is-selected', on);
          items[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        setCardImage(card, colorImage(p, ci, color));
        card.classList.add('l64-color-chosen');
        var v = firstVariant(p, ci, color), link = linkOf(card);
        if (v && link) link.setAttribute('href', link.getAttribute('href').split('?')[0] + '?variant=' + v.id);
      }).catch(function () {});
    }

    /* ---------- events ---------- */
    function stop(e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }

    function activate(e, t) {
      var card = t.closest(CARD);
      if (!card) return;
      var sw = t.closest(SWATCH);
      if (sw) { stop(e); select(card, sw.getAttribute('data-l64-color')); return; }
      var more = t.closest('.l64-swatches--interactive .l64-grid-color-more');
      if (more) { stop(e); if (!expand(card)) { var link = linkOf(card); if (link) window.location.href = link.href; } }
    }

    document.addEventListener('click', function (e) {
      if (!FINE.matches || !cfg().sw) return;
      var t = e.target;
      if (t instanceof Element) activate(e, t);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (!FINE.matches || !cfg().sw || (e.key !== 'Enter' && e.key !== ' ')) return;
      var t = e.target;
      if (t instanceof Element && t.matches(SWATCH + ', .l64-swatches--interactive .l64-grid-color-more')) activate(e, t);
    }, true);

    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse' || !FINE.matches || !cfg().sw) return;
      var t = e.target;
      if (!(t instanceof Element)) return;
      var card = t.closest(CARD);
      if (!card) return;
      prepare(card);
      if (t.closest('.l64-swatches--interactive .l64-grid-color-more')) { expand(card); return; }
      var sw = t.closest(SWATCH);
      if (sw) preview(card, sw.getAttribute('data-l64-color'));
    });

    document.addEventListener('pointerout', function (e) {
      if (e.pointerType !== 'mouse') return;
      var t = e.target;
      if (!(t instanceof Element)) return;
      var sw = t.closest(SWATCH);
      if (!sw) return;
      var to = e.relatedTarget;
      if (to instanceof Element && sw.contains(to)) return;
      var card = sw.closest(CARD);
      if (card) endPreview(card);
    });

    document.addEventListener('focusin', function (e) {
      if (!FINE.matches || !cfg().sw) return;
      var t = e.target;
      if (!(t instanceof Element)) return;
      var card = t.closest(CARD);
      if (!card) return;
      prepare(card);
      if (t.matches('.l64-swatches--interactive .l64-grid-color-more')) { expand(card); return; }
      if (t.matches(SWATCH)) preview(card, t.getAttribute('data-l64-color'));
    });

    document.addEventListener('focusout', function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.matches(SWATCH)) return;
      var card = t.closest(CARD);
      if (card) endPreview(card);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* END LATITUDE 64 - CARD SWATCH PREVIEW V3.2 */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(() => {
  const rootSelector = '[data-l64-discovery]';
  const cardCache = new Map();

  function wakeDynamicImages(scope) {
    if (!scope) return;

    scope.querySelectorAll('[data-aos]').forEach((element) => {
      element.removeAttribute('data-aos-delay');
      element.removeAttribute('data-aos-duration');

      if (element.getAttribute('data-aos') === 'image-fade-in') {
        element.classList.add('aos-animate');
      }
    });

    scope.querySelectorAll('img.image-element, img.lazyload, img[data-src], img[data-srcset]').forEach((image) => {
      if (image.dataset.src && !image.getAttribute('src')) {
        image.setAttribute('src', image.dataset.src);
      }

      if (image.dataset.srcset && !image.getAttribute('srcset')) {
        image.setAttribute('srcset', image.dataset.srcset);
      }

      image.setAttribute('loading', 'eager');
      image.style.opacity = '1';
      image.style.animation = 'none';
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');
    });

    if (window.lazySizes && window.lazySizes.loader && typeof window.lazySizes.loader.unveil === 'function') {
      scope.querySelectorAll('img.image-element').forEach((image) => {
        try {
          window.lazySizes.loader.unveil(image);
        } catch (error) {
          return;
        }
      });
    }

    if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
      try {
        window.theme.reinitProductGridItem(scope);
      } catch (error) {
        return;
      }
    }

    requestAnimationFrame(() => {
      scope.querySelectorAll('img.image-element').forEach((image) => {
        image.style.opacity = '1';
      });
      window.dispatchEvent(new Event('resize'));
    });
  }

  function getVisibleTabs(root) {
    return Array.from(root.querySelectorAll('[data-l64-tab]')).filter((button) => !button.hidden);
  }

  function refreshTabNavigation(root) {
    const scroller = root.querySelector('[data-l64-tab-scroller]');
    const previous = root.querySelector('[data-l64-tab-step="-1"]');
    const next = root.querySelector('[data-l64-tab-step="1"]');
    if (!scroller || !previous || !next) return;

    const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    previous.disabled = maxScroll <= 2 || scroller.scrollLeft <= 2;
    next.disabled = maxScroll <= 2 || scroller.scrollLeft >= maxScroll - 2;
  }

  function keepTabVisible(root, tab) {
    const scroller = root.querySelector('[data-l64-tab-scroller]');
    if (!scroller || !tab || tab.hidden) return;

    // Scroll only the tab rail, never the product page itself.
    const bounds = scroller.getBoundingClientRect();
    const item = tab.getBoundingClientRect();
    let delta = 0;
    if (item.left < bounds.left) delta = item.left - bounds.left - 6;
    else if (item.right > bounds.right) delta = item.right - bounds.right + 6;

    if (delta !== 0) scroller.scrollLeft += delta;
    requestAnimationFrame(() => refreshTabNavigation(root));
  }

  function activateTab(root, requestedTab, loadContent = true) {
    let button = root.querySelector(`[data-l64-tab="${requestedTab}"]`);
    if (!button || button.hidden) {
      button = getVisibleTabs(root)[0];
    }

    if (!button) {
      root.hidden = true;
      return;
    }

    const tabName = button.dataset.l64Tab;

    root.querySelectorAll('[data-l64-tab]').forEach((tab) => {
      const active = tab === button;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    root.querySelectorAll('[data-l64-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.l64Panel !== tabName;
    });

    if (loadContent && tabName === 'recommended') {
      loadRelated(root);
    }

    if (tabName === 'recently_viewed') {
      wakeDynamicImages(root.querySelector('[data-l64-panel="recently_viewed"]'));
    }

    keepTabVisible(root, button);
    refreshTabNavigation(root);
  }

  function hideTab(root, tabName) {
    const button = root.querySelector(`[data-l64-tab="${tabName}"]`);
    if (!button) return;

    const wasActive = button.getAttribute('aria-selected') === 'true';
    button.hidden = true;

    if (wasActive) {
      const fallback = getVisibleTabs(root)[0];
      if (fallback) {
        activateTab(root, fallback.dataset.l64Tab);
      } else {
        root.hidden = true;
      }
    }
    requestAnimationFrame(() => refreshTabNavigation(root));
  }

  async function loadRelated(root) {
    if (!root.querySelector('[data-l64-tab="recommended"]')) return;

    const state = root.dataset.l64RelatedState;
    if (state === 'loading' || state === 'loaded' || state === 'empty') return;

    const panel = root.querySelector('[data-l64-panel="recommended"]');
    const url = root.dataset.relatedUrl;
    if (!panel || !url) return;

    root.dataset.l64RelatedState = 'loading';
    panel.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const source = doc.querySelector('[data-l64-related-source]');
      const hasProducts = source && source.querySelector('.grid-product');

      if (!hasProducts) {
        root.dataset.l64RelatedState = 'empty';
        hideTab(root, 'recommended');
        return;
      }

      panel.innerHTML = source.innerHTML;
      wakeDynamicImages(panel);
      root.dataset.l64RelatedState = 'loaded';
    } catch (error) {
      root.dataset.l64RelatedState = 'empty';
      hideTab(root, 'recommended');
    } finally {
      panel.removeAttribute('aria-busy');
    }
  }

  function getHandleFromCard(card) {
    if (!card) return '';
    if (card.dataset.productHandle) return card.dataset.productHandle;

    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function findNativeRecentSource(root) {
    const ownSource = root.querySelector('[data-l64-recent-source]');
    if (ownSource && ownSource.querySelector('.grid-product')) return ownSource;

    const externalSources = Array.from(document.querySelectorAll('[id^="RecentlyViewed-"]'));
    return externalSources.find((source) => source !== ownSource && source.querySelector('.grid-product')) || ownSource;
  }

  async function fetchStyledCard(root, handle) {
    if (!handle) return '';
    const cacheKey = `${root.dataset.sectionId}:${root.dataset.showProductSubtitles}:${handle}`;
    if (cardCache.has(cacheKey)) return cardCache.get(cacheKey);

    const sectionId = root.dataset.sectionId;
    if (!sectionId) return '';

    const shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    const base = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
    const url = `${base}products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(sectionId)}`;

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) return '';

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const template = doc.querySelector('template[data-l64-current-product-card-template]');
      if (!template) return '';

      let card = template.content ? template.content.querySelector('.grid-product') : null;
      if (!card && template.innerHTML) {
        const holder = document.createElement('div');
        holder.innerHTML = template.innerHTML;
        card = holder.querySelector('.grid-product');
      }

      const html = card ? card.outerHTML : '';
      if (html) cardCache.set(cacheKey, html);
      return html;
    } catch (error) {
      return '';
    }
  }

  async function syncRecentlyViewed(root) {
    const tab = root.querySelector('[data-l64-tab="recently_viewed"]');
    const panel = root.querySelector('[data-l64-panel="recently_viewed"]');
    const target = root.querySelector('[data-l64-recent-target]');
    const source = findNativeRecentSource(root);
    if (!tab || !panel || !target || !source) return;

    const cards = Array.from(source.querySelectorAll('.grid-product'));
    if (!cards.length) return;

    const limit = Math.max(1, Number.parseInt(root.dataset.recentLimit || '4', 10));
    const entries = cards.slice(0, limit).map((card) => ({
      handle: getHandleFromCard(card),
      fallback: card.outerHTML
    }));
    const signature = entries.map((entry) => entry.handle || entry.fallback.length).join('|');

    if (target.dataset.l64RecentSignature === signature && target.children.length) {
      tab.hidden = false;
      requestAnimationFrame(() => refreshTabNavigation(root));
      return;
    }

    panel.setAttribute('aria-busy', 'true');

    try {
      const rendered = await Promise.all(entries.map(async (entry) => {
        if (!entry.handle) return entry.fallback;
        const styled = await fetchStyledCard(root, entry.handle);
        return styled || entry.fallback;
      }));

      const validCards = rendered.filter(Boolean);
      if (!validCards.length) return;

      target.innerHTML = validCards.join('');
      target.dataset.l64RecentSignature = signature;
      wakeDynamicImages(target);
      tab.hidden = false;
      requestAnimationFrame(() => refreshTabNavigation(root));

           /* Recently viewed as default: switch to it once the history has loaded, unless the customer
         has already picked a tab themselves. */
      if (root.dataset.defaultTab === 'recently_viewed' && root.dataset.l64UserPicked !== 'true') {
        activateTab(root, 'recently_viewed', false);
      }
    } finally {
      panel.removeAttribute('aria-busy');
    }
  }

  function setupRecentlyViewed(root) {
    const tab = root.querySelector('[data-l64-tab="recently_viewed"]');
    const ownSource = root.querySelector('[data-l64-recent-source]');
    if (!tab || !ownSource) return;

    tab.hidden = true;

    const observer = new MutationObserver(() => {
      syncRecentlyViewed(root);
    });
    observer.observe(ownSource, { childList: true, subtree: true });

    [250, 750, 1500, 3000].forEach((delay) => {
      window.setTimeout(() => syncRecentlyViewed(root), delay);
    });
  }

  function init(root) {
    if (!root || root.dataset.l64Initialized === 'true') return;
    root.dataset.l64Initialized = 'true';

    setupRecentlyViewed(root);

    const tabScroller = root.querySelector('[data-l64-tab-scroller]');
    if (tabScroller) {
      tabScroller.addEventListener('scroll', () => refreshTabNavigation(root), { passive: true });
      window.addEventListener('resize', () => refreshTabNavigation(root));
    }

    root.addEventListener('click', (event) => {
      const arrow = event.target.closest('[data-l64-tab-step]');
      if (arrow && root.contains(arrow)) {
        const scroller = root.querySelector('[data-l64-tab-scroller]');
        if (!scroller || arrow.disabled) return;
        const direction = Number.parseInt(arrow.dataset.l64TabStep, 10);
        const distance = Math.max(160, Math.round(scroller.clientWidth * .8));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        scroller.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
        return;
      }

            const button = event.target.closest('[data-l64-tab]');
      if (!button || !root.contains(button)) return;
      root.dataset.l64UserPicked = 'true';
      activateTab(root, button.dataset.l64Tab);
    });

    root.addEventListener('keydown', (event) => {
      const current = event.target.closest('[data-l64-tab]');
      if (!current || !root.contains(current)) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      const tabs = getVisibleTabs(root);
      const index = tabs.indexOf(current);
      if (index < 0) return;

      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const next = tabs[(index + direction + tabs.length) % tabs.length];
      next.focus();
      activateTab(root, next.dataset.l64Tab);
    });

    activateTab(root, root.dataset.defaultTab || 'recommended', false);
    requestAnimationFrame(() => refreshTabNavigation(root));

    if (root.querySelector('[data-l64-tab="recommended"]')) {
      const loadDeferredContent = () => loadRelated(root);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadDeferredContent();
        }, { rootMargin: '400px 0px' });
        observer.observe(root);
      } else {
        loadDeferredContent();
      }
    }
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches(rootSelector)) init(scope);
    scope.querySelectorAll(rootSelector).forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
